/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const addProduct = `mutation AddProduct(
  $businessPartnerId: Int
  $condition: String
  $strategy: String
  $recommended_strategy: String
  $initial_amount: Int
  $bank_accounts: String
  $amount_savingsplan: Int
  $counter_savingsplan: Int
  $interval_savingsplan: String
  $wphgProduct: String
) {
  addProduct(
    businessPartnerId: $businessPartnerId
    condition: $condition
    strategy: $strategy
    recommended_strategy: $recommended_strategy
    initial_amount: $initial_amount
    bank_accounts: $bank_accounts
    amount_savingsplan: $amount_savingsplan
    counter_savingsplan: $counter_savingsplan
    interval_savingsplan: $interval_savingsplan
    wphgProduct: $wphgProduct
  )
}
`;
export const addBusinessPartner = `mutation AddBusinessPartner(
  $condition: String
  $strategy: String
  $wphgProduct: String
  $wphgBusinessPartner: String
  $accountType: String
  $recommended_strategy: String
  $initial_amount: Int
  $mmw: String
  $user_choice_years_till_no_income: String
  $amount_savingsplan: Int
  $counter_savingsplan: Int
  $interval_savingsplan: String
) {
  addBusinessPartner(
    condition: $condition
    strategy: $strategy
    wphgProduct: $wphgProduct
    wphgBusinessPartner: $wphgBusinessPartner
    accountType: $accountType
    recommended_strategy: $recommended_strategy
    initial_amount: $initial_amount
    mmw: $mmw
    user_choice_years_till_no_income: $user_choice_years_till_no_income
    amount_savingsplan: $amount_savingsplan
    counter_savingsplan: $counter_savingsplan
    interval_savingsplan: $interval_savingsplan
  )
}
`;
export const acceptPerson = `mutation AcceptPerson(
  $businessPartnerId: String
  $personId: String
  $acceptedByOwner: String
) {
  acceptPerson(
    businessPartnerId: $businessPartnerId
    personId: $personId
    acceptedByOwner: $acceptedByOwner
  )
}
`;
export const changePersonalData = `mutation ChangePersonalData(
  $personId: String!
  $street: String!
  $zip: String!
  $city: String!
  $country: String!
  $phoneNumber: String
  $maritalStatus: String
) {
  changePersonalData(
    personId: $personId
    street: $street
    zip: $zip
    city: $city
    country: $country
    phoneNumber: $phoneNumber
    maritalStatus: $maritalStatus
  )
}
`;
export const withdrawal = `mutation Withdrawal($productId: String, $amount: Float, $moneyGoesTo: String) {
  withdrawal(productId: $productId, amount: $amount, moneyGoesTo: $moneyGoesTo)
}
`;
export const topup = `mutation Topup(
  $personId: String!
  $businessPartnerId: String!
  $productId: String!
  $accountHolder: String!
  $iban: String!
  $bic: String!
  $amount: Float!
) {
  topup(
    personId: $personId
    businessPartnerId: $businessPartnerId
    productId: $productId
    accountHolder: $accountHolder
    iban: $iban
    bic: $bic
    amount: $amount
  )
}
`;
export const identityId = `mutation IdentityId($personId: String, $identityId: String) {
  identityId(personId: $personId, identityId: $identityId)
}
`;
export const attorney = `mutation Attorney($businessPartnerId: String, $additionalMember: String) {
  attorney(
    businessPartnerId: $businessPartnerId
    additionalMember: $additionalMember
  )
}
`;
export const strategyChange = `mutation StrategyChange($productId: String, $strategy: String) {
  strategyChange(productId: $productId, strategy: $strategy)
}
`;
export const contractAccepted = `mutation ContractAccepted($businessPartnerId: String) {
  contractAccepted(businessPartnerId: $businessPartnerId)
}
`;
export const removeProduct = `mutation RemoveProduct($productId: String) {
  removeProduct(productId: $productId)
}
`;
export const removeBusinessPartner = `mutation RemoveBusinessPartner($businessPartnerId: String) {
  removeBusinessPartner(businessPartnerId: $businessPartnerId)
}
`;
export const setReferenceAccount = `mutation SetReferenceAccount(
  $businessPartnerId: String!
  $accountHolder: String!
  $iban: String!
  $bic: String!
  $name: String!
) {
  setReferenceAccount(
    businessPartnerId: $businessPartnerId
    accountHolder: $accountHolder
    iban: $iban
    bic: $bic
    name: $name
  )
}
`;
export const disbursement = `mutation Disbursement($businessPartnerId: String!, $amount: Float!) {
  disbursement(businessPartnerId: $businessPartnerId, amount: $amount)
}
`;
export const sendSavingsPlanEMail = `mutation SendSavingsPlanEMail(
  $productId: String!
  $amount: String!
  $mandat: String!
  $startDate: String!
  $iban: String!
  $bic: String!
  $bank: String!
) {
  sendSavingsPlanEMail(
    productId: $productId
    amount: $amount
    mandat: $mandat
    startDate: $startDate
    iban: $iban
    bic: $bic
    bank: $bank
  )
}
`;
export const kubeBirthCertificate = `mutation KubeBirthCertificate(
  $firstName: String
  $lastName: String
  $businessPartnerId: Int
  $gender: String
  $salutation: String
  $birthDate: String
  $birthPlace: String
  $birthCertificateNumber: String
  $birthCertificateIssuer: String
  $birthCertificateIssuerDate: String
  $birthCertificateCountryOfIssuer: String
) {
  kubeBirthCertificate(
    firstName: $firstName
    lastName: $lastName
    businessPartnerId: $businessPartnerId
    gender: $gender
    salutation: $salutation
    birthDate: $birthDate
    birthPlace: $birthPlace
    birthCertificateNumber: $birthCertificateNumber
    birthCertificateIssuer: $birthCertificateIssuer
    birthCertificateIssuerDate: $birthCertificateIssuerDate
    birthCertificateCountryOfIssuer: $birthCertificateCountryOfIssuer
  )
}
`;
export const kubeDeleteBusinessPartner = `mutation KubeDeleteBusinessPartner($businessPartner: String!) {
  kubeDeleteBusinessPartner(businessPartner: $businessPartner)
}
`;
export const kubeDeleteRegistration = `mutation KubeDeleteRegistration($email: String!) {
  kubeDeleteRegistration(email: $email)
}
`;
export const kubeResetPassword = `mutation KubeResetPassword(
  $email: String!
  $password: String!
  $permanent: Boolean!
  $sendMail: Boolean!
) {
  kubeResetPassword(
    email: $email
    password: $password
    permanent: $permanent
    sendMail: $sendMail
  )
}
`;
export const dataComplete = `mutation DataComplete($businessPartnerId: String) {
  dataComplete(businessPartnerId: $businessPartnerId)
}
`;
export const createPersonInit = `mutation CreatePersonInit($input: CreatePersonInitInput!) {
  createPersonInit(input: $input) {
    id
    eMail
    personId
    businessPartnerId
    personBusinessPartnerMapPersonId
    productConditionMapId
    productId
    depotId
    savingsPlansId
    clearingAccountId
    liquidAccountId
    executionArn
    owner
    members
  }
}
`;
export const updatePersonInit = `mutation UpdatePersonInit($input: UpdatePersonInitInput!) {
  updatePersonInit(input: $input) {
    id
    eMail
    personId
    businessPartnerId
    personBusinessPartnerMapPersonId
    productConditionMapId
    productId
    depotId
    savingsPlansId
    clearingAccountId
    liquidAccountId
    executionArn
    owner
    members
  }
}
`;
export const deletePersonInit = `mutation DeletePersonInit($input: DeletePersonInitInput!) {
  deletePersonInit(input: $input) {
    id
    eMail
    personId
    businessPartnerId
    personBusinessPartnerMapPersonId
    productConditionMapId
    productId
    depotId
    savingsPlansId
    clearingAccountId
    liquidAccountId
    executionArn
    owner
    members
  }
}
`;
export const createPerson = `mutation CreatePerson($input: CreatePersonInput!) {
  createPerson(input: $input) {
    id
    eMail
    externalId
    avaloqId
    postIdent
    communicationEMail
    communicationEMailVerified
    dataComplete
    needToMigrateDoc
    identityId
    gender
    salutation
    title
    titleAdd
    firstName
    middleName
    lastName
    phoneNumber
    mobilePhoneNumber
    passportNumber
    passportIssuer
    passportIssuerDate
    passportValidToDate
    passportPlaceOfIssue
    passportCountryOfIssuer
    birthCertificateNumber
    birthCertificateIssuer
    birthCertificateIssuerDate
    birthCertificateCountryOfIssuer
    birthCertificateInitialEMail
    nationality
    street
    streetNumber
    zip
    city
    state
    country
    addressType
    maritalStatus
    taxNumber
    birthday
    birthplace
    nativeCountry
    occupation
    occupationIndustry
    taxOnlyInGermany
    additionalTax
    mmw
    campaign
    postIdentCaseId
    identificationMethod
    identificationStatus
    identificationType
    utmSource
    utmMedium
    utmCampaign
    utmData
    ndl {
      id
      name
      city
      zip
      street
      streetNr
    }
    businessPartners {
      items {
        id
        role
        waitForCode
        waitForBirthCertificate
        bpId
        createdAt
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    postbox {
      items {
        id
        title
        date
        readTime
        status
        documentKey
        searchField
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    orders {
      items {
        id
        productId
        businessPartnerId
        personId
        amount
        sfType
        sfARN
        sfStartDate
        status
        createdAt
        EndOfStateMachine
        stateMachineToken
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        subOrder {
          items {
            id
            chain
            amount
            status
            type
            createdAt
            transaction {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            order {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    consultant {
      id
      branch
      branchStreet
      branchZip
      branchCity
      branchState
      counter
      firstName
      lastName
      email
      phoneNumber
      mobilePhoneNumber
      status
      s3BucketPicLink
      createdAt
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
    }
    owner
    members
  }
}
`;
export const updatePerson = `mutation UpdatePerson($input: UpdatePersonInput!) {
  updatePerson(input: $input) {
    id
    eMail
    externalId
    avaloqId
    postIdent
    communicationEMail
    communicationEMailVerified
    dataComplete
    needToMigrateDoc
    identityId
    gender
    salutation
    title
    titleAdd
    firstName
    middleName
    lastName
    phoneNumber
    mobilePhoneNumber
    passportNumber
    passportIssuer
    passportIssuerDate
    passportValidToDate
    passportPlaceOfIssue
    passportCountryOfIssuer
    birthCertificateNumber
    birthCertificateIssuer
    birthCertificateIssuerDate
    birthCertificateCountryOfIssuer
    birthCertificateInitialEMail
    nationality
    street
    streetNumber
    zip
    city
    state
    country
    addressType
    maritalStatus
    taxNumber
    birthday
    birthplace
    nativeCountry
    occupation
    occupationIndustry
    taxOnlyInGermany
    additionalTax
    mmw
    campaign
    postIdentCaseId
    identificationMethod
    identificationStatus
    identificationType
    utmSource
    utmMedium
    utmCampaign
    utmData
    ndl {
      id
      name
      city
      zip
      street
      streetNr
    }
    businessPartners {
      items {
        id
        role
        waitForCode
        waitForBirthCertificate
        bpId
        createdAt
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    postbox {
      items {
        id
        title
        date
        readTime
        status
        documentKey
        searchField
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    orders {
      items {
        id
        productId
        businessPartnerId
        personId
        amount
        sfType
        sfARN
        sfStartDate
        status
        createdAt
        EndOfStateMachine
        stateMachineToken
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        subOrder {
          items {
            id
            chain
            amount
            status
            type
            createdAt
            transaction {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            order {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    consultant {
      id
      branch
      branchStreet
      branchZip
      branchCity
      branchState
      counter
      firstName
      lastName
      email
      phoneNumber
      mobilePhoneNumber
      status
      s3BucketPicLink
      createdAt
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
    }
    owner
    members
  }
}
`;
export const deletePerson = `mutation DeletePerson($input: DeletePersonInput!) {
  deletePerson(input: $input) {
    id
    eMail
    externalId
    avaloqId
    postIdent
    communicationEMail
    communicationEMailVerified
    dataComplete
    needToMigrateDoc
    identityId
    gender
    salutation
    title
    titleAdd
    firstName
    middleName
    lastName
    phoneNumber
    mobilePhoneNumber
    passportNumber
    passportIssuer
    passportIssuerDate
    passportValidToDate
    passportPlaceOfIssue
    passportCountryOfIssuer
    birthCertificateNumber
    birthCertificateIssuer
    birthCertificateIssuerDate
    birthCertificateCountryOfIssuer
    birthCertificateInitialEMail
    nationality
    street
    streetNumber
    zip
    city
    state
    country
    addressType
    maritalStatus
    taxNumber
    birthday
    birthplace
    nativeCountry
    occupation
    occupationIndustry
    taxOnlyInGermany
    additionalTax
    mmw
    campaign
    postIdentCaseId
    identificationMethod
    identificationStatus
    identificationType
    utmSource
    utmMedium
    utmCampaign
    utmData
    ndl {
      id
      name
      city
      zip
      street
      streetNr
    }
    businessPartners {
      items {
        id
        role
        waitForCode
        waitForBirthCertificate
        bpId
        createdAt
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    postbox {
      items {
        id
        title
        date
        readTime
        status
        documentKey
        searchField
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    orders {
      items {
        id
        productId
        businessPartnerId
        personId
        amount
        sfType
        sfARN
        sfStartDate
        status
        createdAt
        EndOfStateMachine
        stateMachineToken
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        subOrder {
          items {
            id
            chain
            amount
            status
            type
            createdAt
            transaction {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            order {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    consultant {
      id
      branch
      branchStreet
      branchZip
      branchCity
      branchState
      counter
      firstName
      lastName
      email
      phoneNumber
      mobilePhoneNumber
      status
      s3BucketPicLink
      createdAt
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
    }
    owner
    members
  }
}
`;
export const createPersonBusinessPartnerMap = `mutation CreatePersonBusinessPartnerMap(
  $input: CreatePersonBusinessPartnerMapInput!
) {
  createPersonBusinessPartnerMap(input: $input) {
    id
    role
    waitForCode
    waitForBirthCertificate
    bpId
    createdAt
    businessPartner {
      id
      number
      accountType
      name
      statusContract
      avaloqSync
      advisor
      branch
      balanceActual
      balanceDate
      balanceStart
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      joinedMember
      childMember
      otherMembers
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      stateMachineToken
      createdAt
      openedAt
      closedAt
      wphgExpireDate
      wphg
      businessPartnerCode {
        items {
          id
          attorney
          businessPartnerId
          accountCode
          accountCodeStatus
          acceptedByOwner
          owner
          members
        }
        nextToken
      }
      persons {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      products {
        items {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      bankAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    person {
      id
      eMail
      externalId
      avaloqId
      postIdent
      communicationEMail
      communicationEMailVerified
      dataComplete
      needToMigrateDoc
      identityId
      gender
      salutation
      title
      titleAdd
      firstName
      middleName
      lastName
      phoneNumber
      mobilePhoneNumber
      passportNumber
      passportIssuer
      passportIssuerDate
      passportValidToDate
      passportPlaceOfIssue
      passportCountryOfIssuer
      birthCertificateNumber
      birthCertificateIssuer
      birthCertificateIssuerDate
      birthCertificateCountryOfIssuer
      birthCertificateInitialEMail
      nationality
      street
      streetNumber
      zip
      city
      state
      country
      addressType
      maritalStatus
      taxNumber
      birthday
      birthplace
      nativeCountry
      occupation
      occupationIndustry
      taxOnlyInGermany
      additionalTax
      mmw
      campaign
      postIdentCaseId
      identificationMethod
      identificationStatus
      identificationType
      utmSource
      utmMedium
      utmCampaign
      utmData
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
      businessPartners {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      postbox {
        items {
          id
          title
          date
          readTime
          status
          documentKey
          searchField
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const updatePersonBusinessPartnerMap = `mutation UpdatePersonBusinessPartnerMap(
  $input: UpdatePersonBusinessPartnerMapInput!
) {
  updatePersonBusinessPartnerMap(input: $input) {
    id
    role
    waitForCode
    waitForBirthCertificate
    bpId
    createdAt
    businessPartner {
      id
      number
      accountType
      name
      statusContract
      avaloqSync
      advisor
      branch
      balanceActual
      balanceDate
      balanceStart
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      joinedMember
      childMember
      otherMembers
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      stateMachineToken
      createdAt
      openedAt
      closedAt
      wphgExpireDate
      wphg
      businessPartnerCode {
        items {
          id
          attorney
          businessPartnerId
          accountCode
          accountCodeStatus
          acceptedByOwner
          owner
          members
        }
        nextToken
      }
      persons {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      products {
        items {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      bankAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    person {
      id
      eMail
      externalId
      avaloqId
      postIdent
      communicationEMail
      communicationEMailVerified
      dataComplete
      needToMigrateDoc
      identityId
      gender
      salutation
      title
      titleAdd
      firstName
      middleName
      lastName
      phoneNumber
      mobilePhoneNumber
      passportNumber
      passportIssuer
      passportIssuerDate
      passportValidToDate
      passportPlaceOfIssue
      passportCountryOfIssuer
      birthCertificateNumber
      birthCertificateIssuer
      birthCertificateIssuerDate
      birthCertificateCountryOfIssuer
      birthCertificateInitialEMail
      nationality
      street
      streetNumber
      zip
      city
      state
      country
      addressType
      maritalStatus
      taxNumber
      birthday
      birthplace
      nativeCountry
      occupation
      occupationIndustry
      taxOnlyInGermany
      additionalTax
      mmw
      campaign
      postIdentCaseId
      identificationMethod
      identificationStatus
      identificationType
      utmSource
      utmMedium
      utmCampaign
      utmData
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
      businessPartners {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      postbox {
        items {
          id
          title
          date
          readTime
          status
          documentKey
          searchField
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const deletePersonBusinessPartnerMap = `mutation DeletePersonBusinessPartnerMap(
  $input: DeletePersonBusinessPartnerMapInput!
) {
  deletePersonBusinessPartnerMap(input: $input) {
    id
    role
    waitForCode
    waitForBirthCertificate
    bpId
    createdAt
    businessPartner {
      id
      number
      accountType
      name
      statusContract
      avaloqSync
      advisor
      branch
      balanceActual
      balanceDate
      balanceStart
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      joinedMember
      childMember
      otherMembers
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      stateMachineToken
      createdAt
      openedAt
      closedAt
      wphgExpireDate
      wphg
      businessPartnerCode {
        items {
          id
          attorney
          businessPartnerId
          accountCode
          accountCodeStatus
          acceptedByOwner
          owner
          members
        }
        nextToken
      }
      persons {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      products {
        items {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      bankAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    person {
      id
      eMail
      externalId
      avaloqId
      postIdent
      communicationEMail
      communicationEMailVerified
      dataComplete
      needToMigrateDoc
      identityId
      gender
      salutation
      title
      titleAdd
      firstName
      middleName
      lastName
      phoneNumber
      mobilePhoneNumber
      passportNumber
      passportIssuer
      passportIssuerDate
      passportValidToDate
      passportPlaceOfIssue
      passportCountryOfIssuer
      birthCertificateNumber
      birthCertificateIssuer
      birthCertificateIssuerDate
      birthCertificateCountryOfIssuer
      birthCertificateInitialEMail
      nationality
      street
      streetNumber
      zip
      city
      state
      country
      addressType
      maritalStatus
      taxNumber
      birthday
      birthplace
      nativeCountry
      occupation
      occupationIndustry
      taxOnlyInGermany
      additionalTax
      mmw
      campaign
      postIdentCaseId
      identificationMethod
      identificationStatus
      identificationType
      utmSource
      utmMedium
      utmCampaign
      utmData
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
      businessPartners {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      postbox {
        items {
          id
          title
          date
          readTime
          status
          documentKey
          searchField
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const createConsultant = `mutation CreateConsultant($input: CreateConsultantInput!) {
  createConsultant(input: $input) {
    id
    branch
    branchStreet
    branchZip
    branchCity
    branchState
    counter
    firstName
    lastName
    email
    phoneNumber
    mobilePhoneNumber
    status
    s3BucketPicLink
    createdAt
    ndl {
      id
      name
      city
      zip
      street
      streetNr
    }
  }
}
`;
export const updateConsultant = `mutation UpdateConsultant($input: UpdateConsultantInput!) {
  updateConsultant(input: $input) {
    id
    branch
    branchStreet
    branchZip
    branchCity
    branchState
    counter
    firstName
    lastName
    email
    phoneNumber
    mobilePhoneNumber
    status
    s3BucketPicLink
    createdAt
    ndl {
      id
      name
      city
      zip
      street
      streetNr
    }
  }
}
`;
export const deleteConsultant = `mutation DeleteConsultant($input: DeleteConsultantInput!) {
  deleteConsultant(input: $input) {
    id
    branch
    branchStreet
    branchZip
    branchCity
    branchState
    counter
    firstName
    lastName
    email
    phoneNumber
    mobilePhoneNumber
    status
    s3BucketPicLink
    createdAt
    ndl {
      id
      name
      city
      zip
      street
      streetNr
    }
  }
}
`;
export const createNdl = `mutation CreateNdl($input: CreateNdlInput!) {
  createNdl(input: $input) {
    id
    name
    city
    zip
    street
    streetNr
  }
}
`;
export const updateNdl = `mutation UpdateNdl($input: UpdateNdlInput!) {
  updateNdl(input: $input) {
    id
    name
    city
    zip
    street
    streetNr
  }
}
`;
export const deleteNdl = `mutation DeleteNdl($input: DeleteNdlInput!) {
  deleteNdl(input: $input) {
    id
    name
    city
    zip
    street
    streetNr
  }
}
`;
export const createZipCodeNdl = `mutation CreateZipCodeNdl($input: CreateZipCodeNdlInput!) {
  createZipCodeNdl(input: $input) {
    id
    zipcode
    state
    ndl {
      id
      name
      city
      zip
      street
      streetNr
    }
  }
}
`;
export const updateZipCodeNdl = `mutation UpdateZipCodeNdl($input: UpdateZipCodeNdlInput!) {
  updateZipCodeNdl(input: $input) {
    id
    zipcode
    state
    ndl {
      id
      name
      city
      zip
      street
      streetNr
    }
  }
}
`;
export const deleteZipCodeNdl = `mutation DeleteZipCodeNdl($input: DeleteZipCodeNdlInput!) {
  deleteZipCodeNdl(input: $input) {
    id
    zipcode
    state
    ndl {
      id
      name
      city
      zip
      street
      streetNr
    }
  }
}
`;
export const createBusinessPartner = `mutation CreateBusinessPartner($input: CreateBusinessPartnerInput!) {
  createBusinessPartner(input: $input) {
    id
    number
    accountType
    name
    statusContract
    avaloqSync
    advisor
    branch
    balanceActual
    balanceDate
    balanceStart
    totalChangeBegin
    totalChangeYearStart
    twrPerformanceStart
    twrPerformanceYearStart
    mwrPerformanceStart
    mwrPerformanceYearStart
    joinedMember
    childMember
    otherMembers
    portfolioHistory
    portfolioHistoryYear
    performanceStartDate
    stateMachineToken
    createdAt
    openedAt
    closedAt
    wphgExpireDate
    wphg
    businessPartnerCode {
      items {
        id
        attorney
        businessPartnerId
        accountCode
        accountCodeStatus
        acceptedByOwner
        owner
        members
      }
      nextToken
    }
    persons {
      items {
        id
        role
        waitForCode
        waitForBirthCertificate
        bpId
        createdAt
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    products {
      items {
        id
        number
        name
        category
        strategy
        recommendedStrategy
        recommendedName
        balanceActual
        balanceStart
        balanceDate
        totalChangeBegin
        totalChangeYearStart
        twrPerformanceStart
        twrPerformanceYearStart
        mwrPerformanceStart
        mwrPerformanceYearStart
        statusProduct
        portfolioHistory
        portfolioHistoryYear
        performanceStartDate
        retirementYear
        stateMachineToken
        wphgInitialAmount
        initialAmountReceived
        wphgExpireDate
        wphg
        balanceClosed
        balanceClosedDate
        createdAt
        depotBalance
        depotItems
        cashoutPlan {
          id
          rate
          counter
          interval
          startDate
          endDate
          nextDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        liquidAccounts {
          items {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        depots {
          items {
            id
            number
            balance
            twr
            mwr
            profit
            depotItems {
              items {
                id
                name
                number
                quantity
                value
                valueCurrency
                einstandskurs
                aktuellerKurs
                notRealGUV
                notRealGUVCurrency
                notRealGUVPercentage
                referenceDate
                avaloqAssetId
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        conditions {
          items {
            id
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            condition {
              id
              advisor
              category
              strategy
              accountType
              minInvest
              minIncrease
              minDecrease
              minRate
              allowance
              cashoutplan
              savingsplan
              consulting
              feeQuirion
              feeAdvisor
              validFrom
              validTo
              homepageUrl
              conditionLink
              advisorConfirmText
              contact
              phoneNumber
              description
              descriptionTitle
              title
              name
              newBp
              newIps
              costProfile
              products {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
            }
            owner
            members
          }
          nextToken
        }
        actions {
          items {
            id
            action {
              id
              trigger
              dateFrom
              dateTo
              advisor
              category
              accountType
              existingCustomer
              newCustomer
              tasks
              name
              actionTCLink
              accept
              products {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    orders {
      items {
        id
        productId
        businessPartnerId
        personId
        amount
        sfType
        sfARN
        sfStartDate
        status
        createdAt
        EndOfStateMachine
        stateMachineToken
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        subOrder {
          items {
            id
            chain
            amount
            status
            type
            createdAt
            transaction {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            order {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    bankAccounts {
      items {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    consultant {
      id
      branch
      branchStreet
      branchZip
      branchCity
      branchState
      counter
      firstName
      lastName
      email
      phoneNumber
      mobilePhoneNumber
      status
      s3BucketPicLink
      createdAt
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
    }
    owner
    members
  }
}
`;
export const updateBusinessPartner = `mutation UpdateBusinessPartner($input: UpdateBusinessPartnerInput!) {
  updateBusinessPartner(input: $input) {
    id
    number
    accountType
    name
    statusContract
    avaloqSync
    advisor
    branch
    balanceActual
    balanceDate
    balanceStart
    totalChangeBegin
    totalChangeYearStart
    twrPerformanceStart
    twrPerformanceYearStart
    mwrPerformanceStart
    mwrPerformanceYearStart
    joinedMember
    childMember
    otherMembers
    portfolioHistory
    portfolioHistoryYear
    performanceStartDate
    stateMachineToken
    createdAt
    openedAt
    closedAt
    wphgExpireDate
    wphg
    businessPartnerCode {
      items {
        id
        attorney
        businessPartnerId
        accountCode
        accountCodeStatus
        acceptedByOwner
        owner
        members
      }
      nextToken
    }
    persons {
      items {
        id
        role
        waitForCode
        waitForBirthCertificate
        bpId
        createdAt
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    products {
      items {
        id
        number
        name
        category
        strategy
        recommendedStrategy
        recommendedName
        balanceActual
        balanceStart
        balanceDate
        totalChangeBegin
        totalChangeYearStart
        twrPerformanceStart
        twrPerformanceYearStart
        mwrPerformanceStart
        mwrPerformanceYearStart
        statusProduct
        portfolioHistory
        portfolioHistoryYear
        performanceStartDate
        retirementYear
        stateMachineToken
        wphgInitialAmount
        initialAmountReceived
        wphgExpireDate
        wphg
        balanceClosed
        balanceClosedDate
        createdAt
        depotBalance
        depotItems
        cashoutPlan {
          id
          rate
          counter
          interval
          startDate
          endDate
          nextDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        liquidAccounts {
          items {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        depots {
          items {
            id
            number
            balance
            twr
            mwr
            profit
            depotItems {
              items {
                id
                name
                number
                quantity
                value
                valueCurrency
                einstandskurs
                aktuellerKurs
                notRealGUV
                notRealGUVCurrency
                notRealGUVPercentage
                referenceDate
                avaloqAssetId
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        conditions {
          items {
            id
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            condition {
              id
              advisor
              category
              strategy
              accountType
              minInvest
              minIncrease
              minDecrease
              minRate
              allowance
              cashoutplan
              savingsplan
              consulting
              feeQuirion
              feeAdvisor
              validFrom
              validTo
              homepageUrl
              conditionLink
              advisorConfirmText
              contact
              phoneNumber
              description
              descriptionTitle
              title
              name
              newBp
              newIps
              costProfile
              products {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
            }
            owner
            members
          }
          nextToken
        }
        actions {
          items {
            id
            action {
              id
              trigger
              dateFrom
              dateTo
              advisor
              category
              accountType
              existingCustomer
              newCustomer
              tasks
              name
              actionTCLink
              accept
              products {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    orders {
      items {
        id
        productId
        businessPartnerId
        personId
        amount
        sfType
        sfARN
        sfStartDate
        status
        createdAt
        EndOfStateMachine
        stateMachineToken
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        subOrder {
          items {
            id
            chain
            amount
            status
            type
            createdAt
            transaction {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            order {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    bankAccounts {
      items {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    consultant {
      id
      branch
      branchStreet
      branchZip
      branchCity
      branchState
      counter
      firstName
      lastName
      email
      phoneNumber
      mobilePhoneNumber
      status
      s3BucketPicLink
      createdAt
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
    }
    owner
    members
  }
}
`;
export const deleteBusinessPartner = `mutation DeleteBusinessPartner($input: DeleteBusinessPartnerInput!) {
  deleteBusinessPartner(input: $input) {
    id
    number
    accountType
    name
    statusContract
    avaloqSync
    advisor
    branch
    balanceActual
    balanceDate
    balanceStart
    totalChangeBegin
    totalChangeYearStart
    twrPerformanceStart
    twrPerformanceYearStart
    mwrPerformanceStart
    mwrPerformanceYearStart
    joinedMember
    childMember
    otherMembers
    portfolioHistory
    portfolioHistoryYear
    performanceStartDate
    stateMachineToken
    createdAt
    openedAt
    closedAt
    wphgExpireDate
    wphg
    businessPartnerCode {
      items {
        id
        attorney
        businessPartnerId
        accountCode
        accountCodeStatus
        acceptedByOwner
        owner
        members
      }
      nextToken
    }
    persons {
      items {
        id
        role
        waitForCode
        waitForBirthCertificate
        bpId
        createdAt
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    products {
      items {
        id
        number
        name
        category
        strategy
        recommendedStrategy
        recommendedName
        balanceActual
        balanceStart
        balanceDate
        totalChangeBegin
        totalChangeYearStart
        twrPerformanceStart
        twrPerformanceYearStart
        mwrPerformanceStart
        mwrPerformanceYearStart
        statusProduct
        portfolioHistory
        portfolioHistoryYear
        performanceStartDate
        retirementYear
        stateMachineToken
        wphgInitialAmount
        initialAmountReceived
        wphgExpireDate
        wphg
        balanceClosed
        balanceClosedDate
        createdAt
        depotBalance
        depotItems
        cashoutPlan {
          id
          rate
          counter
          interval
          startDate
          endDate
          nextDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        liquidAccounts {
          items {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        depots {
          items {
            id
            number
            balance
            twr
            mwr
            profit
            depotItems {
              items {
                id
                name
                number
                quantity
                value
                valueCurrency
                einstandskurs
                aktuellerKurs
                notRealGUV
                notRealGUVCurrency
                notRealGUVPercentage
                referenceDate
                avaloqAssetId
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        conditions {
          items {
            id
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            condition {
              id
              advisor
              category
              strategy
              accountType
              minInvest
              minIncrease
              minDecrease
              minRate
              allowance
              cashoutplan
              savingsplan
              consulting
              feeQuirion
              feeAdvisor
              validFrom
              validTo
              homepageUrl
              conditionLink
              advisorConfirmText
              contact
              phoneNumber
              description
              descriptionTitle
              title
              name
              newBp
              newIps
              costProfile
              products {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
            }
            owner
            members
          }
          nextToken
        }
        actions {
          items {
            id
            action {
              id
              trigger
              dateFrom
              dateTo
              advisor
              category
              accountType
              existingCustomer
              newCustomer
              tasks
              name
              actionTCLink
              accept
              products {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    orders {
      items {
        id
        productId
        businessPartnerId
        personId
        amount
        sfType
        sfARN
        sfStartDate
        status
        createdAt
        EndOfStateMachine
        stateMachineToken
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        subOrder {
          items {
            id
            chain
            amount
            status
            type
            createdAt
            transaction {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            order {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    bankAccounts {
      items {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    consultant {
      id
      branch
      branchStreet
      branchZip
      branchCity
      branchState
      counter
      firstName
      lastName
      email
      phoneNumber
      mobilePhoneNumber
      status
      s3BucketPicLink
      createdAt
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
    }
    owner
    members
  }
}
`;
export const createBusinessPartnerCode = `mutation CreateBusinessPartnerCode($input: CreateBusinessPartnerCodeInput!) {
  createBusinessPartnerCode(input: $input) {
    id
    attorney
    businessPartnerId
    accountCode
    accountCodeStatus
    acceptedByOwner
    owner
    members
  }
}
`;
export const updateBusinessPartnerCode = `mutation UpdateBusinessPartnerCode($input: UpdateBusinessPartnerCodeInput!) {
  updateBusinessPartnerCode(input: $input) {
    id
    attorney
    businessPartnerId
    accountCode
    accountCodeStatus
    acceptedByOwner
    owner
    members
  }
}
`;
export const deleteBusinessPartnerCode = `mutation DeleteBusinessPartnerCode($input: DeleteBusinessPartnerCodeInput!) {
  deleteBusinessPartnerCode(input: $input) {
    id
    attorney
    businessPartnerId
    accountCode
    accountCodeStatus
    acceptedByOwner
    owner
    members
  }
}
`;
export const createMarketingAktion = `mutation CreateMarketingAktion($input: CreateMarketingAktionInput!) {
  createMarketingAktion(input: $input) {
    id
    personId
    businessPartnerId
    productId
    actionId
    case
    createdAt
    owner
    members
  }
}
`;
export const updateMarketingAktion = `mutation UpdateMarketingAktion($input: UpdateMarketingAktionInput!) {
  updateMarketingAktion(input: $input) {
    id
    personId
    businessPartnerId
    productId
    actionId
    case
    createdAt
    owner
    members
  }
}
`;
export const deleteMarketingAktion = `mutation DeleteMarketingAktion($input: DeleteMarketingAktionInput!) {
  deleteMarketingAktion(input: $input) {
    id
    personId
    businessPartnerId
    productId
    actionId
    case
    createdAt
    owner
    members
  }
}
`;
export const createProduct = `mutation CreateProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    id
    number
    name
    category
    strategy
    recommendedStrategy
    recommendedName
    balanceActual
    balanceStart
    balanceDate
    totalChangeBegin
    totalChangeYearStart
    twrPerformanceStart
    twrPerformanceYearStart
    mwrPerformanceStart
    mwrPerformanceYearStart
    statusProduct
    portfolioHistory
    portfolioHistoryYear
    performanceStartDate
    retirementYear
    stateMachineToken
    wphgInitialAmount
    initialAmountReceived
    wphgExpireDate
    wphg
    balanceClosed
    balanceClosedDate
    createdAt
    depotBalance
    depotItems
    cashoutPlan {
      id
      rate
      counter
      interval
      startDate
      endDate
      nextDate
      bankAccount {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      owner
      members
    }
    liquidAccounts {
      items {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    savingsPlans {
      items {
        id
        name
        rate
        startDate
        endDate
        nextDate
        executionDay
        counter
        interval
        mandat
        mandatSignatureDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    depots {
      items {
        id
        number
        balance
        twr
        mwr
        profit
        depotItems {
          items {
            id
            name
            number
            quantity
            value
            valueCurrency
            einstandskurs
            aktuellerKurs
            notRealGUV
            notRealGUVCurrency
            notRealGUVPercentage
            referenceDate
            avaloqAssetId
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    orders {
      items {
        id
        productId
        businessPartnerId
        personId
        amount
        sfType
        sfARN
        sfStartDate
        status
        createdAt
        EndOfStateMachine
        stateMachineToken
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        subOrder {
          items {
            id
            chain
            amount
            status
            type
            createdAt
            transaction {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            order {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    conditions {
      items {
        id
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        condition {
          id
          advisor
          category
          strategy
          accountType
          minInvest
          minIncrease
          minDecrease
          minRate
          allowance
          cashoutplan
          savingsplan
          consulting
          feeQuirion
          feeAdvisor
          validFrom
          validTo
          homepageUrl
          conditionLink
          advisorConfirmText
          contact
          phoneNumber
          description
          descriptionTitle
          title
          name
          newBp
          newIps
          costProfile
          products {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
        }
        owner
        members
      }
      nextToken
    }
    actions {
      items {
        id
        action {
          id
          trigger
          dateFrom
          dateTo
          advisor
          category
          accountType
          existingCustomer
          newCustomer
          tasks
          name
          actionTCLink
          accept
          products {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const updateProduct = `mutation UpdateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    id
    number
    name
    category
    strategy
    recommendedStrategy
    recommendedName
    balanceActual
    balanceStart
    balanceDate
    totalChangeBegin
    totalChangeYearStart
    twrPerformanceStart
    twrPerformanceYearStart
    mwrPerformanceStart
    mwrPerformanceYearStart
    statusProduct
    portfolioHistory
    portfolioHistoryYear
    performanceStartDate
    retirementYear
    stateMachineToken
    wphgInitialAmount
    initialAmountReceived
    wphgExpireDate
    wphg
    balanceClosed
    balanceClosedDate
    createdAt
    depotBalance
    depotItems
    cashoutPlan {
      id
      rate
      counter
      interval
      startDate
      endDate
      nextDate
      bankAccount {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      owner
      members
    }
    liquidAccounts {
      items {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    savingsPlans {
      items {
        id
        name
        rate
        startDate
        endDate
        nextDate
        executionDay
        counter
        interval
        mandat
        mandatSignatureDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    depots {
      items {
        id
        number
        balance
        twr
        mwr
        profit
        depotItems {
          items {
            id
            name
            number
            quantity
            value
            valueCurrency
            einstandskurs
            aktuellerKurs
            notRealGUV
            notRealGUVCurrency
            notRealGUVPercentage
            referenceDate
            avaloqAssetId
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    orders {
      items {
        id
        productId
        businessPartnerId
        personId
        amount
        sfType
        sfARN
        sfStartDate
        status
        createdAt
        EndOfStateMachine
        stateMachineToken
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        subOrder {
          items {
            id
            chain
            amount
            status
            type
            createdAt
            transaction {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            order {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    conditions {
      items {
        id
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        condition {
          id
          advisor
          category
          strategy
          accountType
          minInvest
          minIncrease
          minDecrease
          minRate
          allowance
          cashoutplan
          savingsplan
          consulting
          feeQuirion
          feeAdvisor
          validFrom
          validTo
          homepageUrl
          conditionLink
          advisorConfirmText
          contact
          phoneNumber
          description
          descriptionTitle
          title
          name
          newBp
          newIps
          costProfile
          products {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
        }
        owner
        members
      }
      nextToken
    }
    actions {
      items {
        id
        action {
          id
          trigger
          dateFrom
          dateTo
          advisor
          category
          accountType
          existingCustomer
          newCustomer
          tasks
          name
          actionTCLink
          accept
          products {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const deleteProduct = `mutation DeleteProduct($input: DeleteProductInput!) {
  deleteProduct(input: $input) {
    id
    number
    name
    category
    strategy
    recommendedStrategy
    recommendedName
    balanceActual
    balanceStart
    balanceDate
    totalChangeBegin
    totalChangeYearStart
    twrPerformanceStart
    twrPerformanceYearStart
    mwrPerformanceStart
    mwrPerformanceYearStart
    statusProduct
    portfolioHistory
    portfolioHistoryYear
    performanceStartDate
    retirementYear
    stateMachineToken
    wphgInitialAmount
    initialAmountReceived
    wphgExpireDate
    wphg
    balanceClosed
    balanceClosedDate
    createdAt
    depotBalance
    depotItems
    cashoutPlan {
      id
      rate
      counter
      interval
      startDate
      endDate
      nextDate
      bankAccount {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      owner
      members
    }
    liquidAccounts {
      items {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    savingsPlans {
      items {
        id
        name
        rate
        startDate
        endDate
        nextDate
        executionDay
        counter
        interval
        mandat
        mandatSignatureDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    depots {
      items {
        id
        number
        balance
        twr
        mwr
        profit
        depotItems {
          items {
            id
            name
            number
            quantity
            value
            valueCurrency
            einstandskurs
            aktuellerKurs
            notRealGUV
            notRealGUVCurrency
            notRealGUVPercentage
            referenceDate
            avaloqAssetId
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    orders {
      items {
        id
        productId
        businessPartnerId
        personId
        amount
        sfType
        sfARN
        sfStartDate
        status
        createdAt
        EndOfStateMachine
        stateMachineToken
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        businessPartner {
          id
          number
          accountType
          name
          statusContract
          avaloqSync
          advisor
          branch
          balanceActual
          balanceDate
          balanceStart
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          joinedMember
          childMember
          otherMembers
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          stateMachineToken
          createdAt
          openedAt
          closedAt
          wphgExpireDate
          wphg
          businessPartnerCode {
            items {
              id
              attorney
              businessPartnerId
              accountCode
              accountCodeStatus
              acceptedByOwner
              owner
              members
            }
            nextToken
          }
          persons {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          products {
            items {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          bankAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        person {
          id
          eMail
          externalId
          avaloqId
          postIdent
          communicationEMail
          communicationEMailVerified
          dataComplete
          needToMigrateDoc
          identityId
          gender
          salutation
          title
          titleAdd
          firstName
          middleName
          lastName
          phoneNumber
          mobilePhoneNumber
          passportNumber
          passportIssuer
          passportIssuerDate
          passportValidToDate
          passportPlaceOfIssue
          passportCountryOfIssuer
          birthCertificateNumber
          birthCertificateIssuer
          birthCertificateIssuerDate
          birthCertificateCountryOfIssuer
          birthCertificateInitialEMail
          nationality
          street
          streetNumber
          zip
          city
          state
          country
          addressType
          maritalStatus
          taxNumber
          birthday
          birthplace
          nativeCountry
          occupation
          occupationIndustry
          taxOnlyInGermany
          additionalTax
          mmw
          campaign
          postIdentCaseId
          identificationMethod
          identificationStatus
          identificationType
          utmSource
          utmMedium
          utmCampaign
          utmData
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
          businessPartners {
            items {
              id
              role
              waitForCode
              waitForBirthCertificate
              bpId
              createdAt
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          postbox {
            items {
              id
              title
              date
              readTime
              status
              documentKey
              searchField
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          consultant {
            id
            branch
            branchStreet
            branchZip
            branchCity
            branchState
            counter
            firstName
            lastName
            email
            phoneNumber
            mobilePhoneNumber
            status
            s3BucketPicLink
            createdAt
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
          }
          owner
          members
        }
        subOrder {
          items {
            id
            chain
            amount
            status
            type
            createdAt
            transaction {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            order {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      nextToken
    }
    conditions {
      items {
        id
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        condition {
          id
          advisor
          category
          strategy
          accountType
          minInvest
          minIncrease
          minDecrease
          minRate
          allowance
          cashoutplan
          savingsplan
          consulting
          feeQuirion
          feeAdvisor
          validFrom
          validTo
          homepageUrl
          conditionLink
          advisorConfirmText
          contact
          phoneNumber
          description
          descriptionTitle
          title
          name
          newBp
          newIps
          costProfile
          products {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
        }
        owner
        members
      }
      nextToken
    }
    actions {
      items {
        id
        action {
          id
          trigger
          dateFrom
          dateTo
          advisor
          category
          accountType
          existingCustomer
          newCustomer
          tasks
          name
          actionTCLink
          accept
          products {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const createProductConditionMap = `mutation CreateProductConditionMap($input: CreateProductConditionMapInput!) {
  createProductConditionMap(input: $input) {
    id
    product {
      id
      number
      name
      category
      strategy
      recommendedStrategy
      recommendedName
      balanceActual
      balanceStart
      balanceDate
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      statusProduct
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      retirementYear
      stateMachineToken
      wphgInitialAmount
      initialAmountReceived
      wphgExpireDate
      wphg
      balanceClosed
      balanceClosedDate
      createdAt
      depotBalance
      depotItems
      cashoutPlan {
        id
        rate
        counter
        interval
        startDate
        endDate
        nextDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      liquidAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      depots {
        items {
          id
          number
          balance
          twr
          mwr
          profit
          depotItems {
            items {
              id
              name
              number
              quantity
              value
              valueCurrency
              einstandskurs
              aktuellerKurs
              notRealGUV
              notRealGUVCurrency
              notRealGUVPercentage
              referenceDate
              avaloqAssetId
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      conditions {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
      actions {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    condition {
      id
      advisor
      category
      strategy
      accountType
      minInvest
      minIncrease
      minDecrease
      minRate
      allowance
      cashoutplan
      savingsplan
      consulting
      feeQuirion
      feeAdvisor
      validFrom
      validTo
      homepageUrl
      conditionLink
      advisorConfirmText
      contact
      phoneNumber
      description
      descriptionTitle
      title
      name
      newBp
      newIps
      costProfile
      products {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
    }
    owner
    members
  }
}
`;
export const updateProductConditionMap = `mutation UpdateProductConditionMap($input: UpdateProductConditionMapInput!) {
  updateProductConditionMap(input: $input) {
    id
    product {
      id
      number
      name
      category
      strategy
      recommendedStrategy
      recommendedName
      balanceActual
      balanceStart
      balanceDate
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      statusProduct
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      retirementYear
      stateMachineToken
      wphgInitialAmount
      initialAmountReceived
      wphgExpireDate
      wphg
      balanceClosed
      balanceClosedDate
      createdAt
      depotBalance
      depotItems
      cashoutPlan {
        id
        rate
        counter
        interval
        startDate
        endDate
        nextDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      liquidAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      depots {
        items {
          id
          number
          balance
          twr
          mwr
          profit
          depotItems {
            items {
              id
              name
              number
              quantity
              value
              valueCurrency
              einstandskurs
              aktuellerKurs
              notRealGUV
              notRealGUVCurrency
              notRealGUVPercentage
              referenceDate
              avaloqAssetId
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      conditions {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
      actions {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    condition {
      id
      advisor
      category
      strategy
      accountType
      minInvest
      minIncrease
      minDecrease
      minRate
      allowance
      cashoutplan
      savingsplan
      consulting
      feeQuirion
      feeAdvisor
      validFrom
      validTo
      homepageUrl
      conditionLink
      advisorConfirmText
      contact
      phoneNumber
      description
      descriptionTitle
      title
      name
      newBp
      newIps
      costProfile
      products {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
    }
    owner
    members
  }
}
`;
export const deleteProductConditionMap = `mutation DeleteProductConditionMap($input: DeleteProductConditionMapInput!) {
  deleteProductConditionMap(input: $input) {
    id
    product {
      id
      number
      name
      category
      strategy
      recommendedStrategy
      recommendedName
      balanceActual
      balanceStart
      balanceDate
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      statusProduct
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      retirementYear
      stateMachineToken
      wphgInitialAmount
      initialAmountReceived
      wphgExpireDate
      wphg
      balanceClosed
      balanceClosedDate
      createdAt
      depotBalance
      depotItems
      cashoutPlan {
        id
        rate
        counter
        interval
        startDate
        endDate
        nextDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      liquidAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      depots {
        items {
          id
          number
          balance
          twr
          mwr
          profit
          depotItems {
            items {
              id
              name
              number
              quantity
              value
              valueCurrency
              einstandskurs
              aktuellerKurs
              notRealGUV
              notRealGUVCurrency
              notRealGUVPercentage
              referenceDate
              avaloqAssetId
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      conditions {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
      actions {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    condition {
      id
      advisor
      category
      strategy
      accountType
      minInvest
      minIncrease
      minDecrease
      minRate
      allowance
      cashoutplan
      savingsplan
      consulting
      feeQuirion
      feeAdvisor
      validFrom
      validTo
      homepageUrl
      conditionLink
      advisorConfirmText
      contact
      phoneNumber
      description
      descriptionTitle
      title
      name
      newBp
      newIps
      costProfile
      products {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
    }
    owner
    members
  }
}
`;
export const createCondition = `mutation CreateCondition($input: CreateConditionInput!) {
  createCondition(input: $input) {
    id
    advisor
    category
    strategy
    accountType
    minInvest
    minIncrease
    minDecrease
    minRate
    allowance
    cashoutplan
    savingsplan
    consulting
    feeQuirion
    feeAdvisor
    validFrom
    validTo
    homepageUrl
    conditionLink
    advisorConfirmText
    contact
    phoneNumber
    description
    descriptionTitle
    title
    name
    newBp
    newIps
    costProfile
    products {
      items {
        id
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        condition {
          id
          advisor
          category
          strategy
          accountType
          minInvest
          minIncrease
          minDecrease
          minRate
          allowance
          cashoutplan
          savingsplan
          consulting
          feeQuirion
          feeAdvisor
          validFrom
          validTo
          homepageUrl
          conditionLink
          advisorConfirmText
          contact
          phoneNumber
          description
          descriptionTitle
          title
          name
          newBp
          newIps
          costProfile
          products {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
        }
        owner
        members
      }
      nextToken
    }
  }
}
`;
export const updateCondition = `mutation UpdateCondition($input: UpdateConditionInput!) {
  updateCondition(input: $input) {
    id
    advisor
    category
    strategy
    accountType
    minInvest
    minIncrease
    minDecrease
    minRate
    allowance
    cashoutplan
    savingsplan
    consulting
    feeQuirion
    feeAdvisor
    validFrom
    validTo
    homepageUrl
    conditionLink
    advisorConfirmText
    contact
    phoneNumber
    description
    descriptionTitle
    title
    name
    newBp
    newIps
    costProfile
    products {
      items {
        id
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        condition {
          id
          advisor
          category
          strategy
          accountType
          minInvest
          minIncrease
          minDecrease
          minRate
          allowance
          cashoutplan
          savingsplan
          consulting
          feeQuirion
          feeAdvisor
          validFrom
          validTo
          homepageUrl
          conditionLink
          advisorConfirmText
          contact
          phoneNumber
          description
          descriptionTitle
          title
          name
          newBp
          newIps
          costProfile
          products {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
        }
        owner
        members
      }
      nextToken
    }
  }
}
`;
export const deleteCondition = `mutation DeleteCondition($input: DeleteConditionInput!) {
  deleteCondition(input: $input) {
    id
    advisor
    category
    strategy
    accountType
    minInvest
    minIncrease
    minDecrease
    minRate
    allowance
    cashoutplan
    savingsplan
    consulting
    feeQuirion
    feeAdvisor
    validFrom
    validTo
    homepageUrl
    conditionLink
    advisorConfirmText
    contact
    phoneNumber
    description
    descriptionTitle
    title
    name
    newBp
    newIps
    costProfile
    products {
      items {
        id
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        condition {
          id
          advisor
          category
          strategy
          accountType
          minInvest
          minIncrease
          minDecrease
          minRate
          allowance
          cashoutplan
          savingsplan
          consulting
          feeQuirion
          feeAdvisor
          validFrom
          validTo
          homepageUrl
          conditionLink
          advisorConfirmText
          contact
          phoneNumber
          description
          descriptionTitle
          title
          name
          newBp
          newIps
          costProfile
          products {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
        }
        owner
        members
      }
      nextToken
    }
  }
}
`;
export const createProductActionMap = `mutation CreateProductActionMap($input: CreateProductActionMapInput!) {
  createProductActionMap(input: $input) {
    id
    action {
      id
      trigger
      dateFrom
      dateTo
      advisor
      category
      accountType
      existingCustomer
      newCustomer
      tasks
      name
      actionTCLink
      accept
      products {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    product {
      id
      number
      name
      category
      strategy
      recommendedStrategy
      recommendedName
      balanceActual
      balanceStart
      balanceDate
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      statusProduct
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      retirementYear
      stateMachineToken
      wphgInitialAmount
      initialAmountReceived
      wphgExpireDate
      wphg
      balanceClosed
      balanceClosedDate
      createdAt
      depotBalance
      depotItems
      cashoutPlan {
        id
        rate
        counter
        interval
        startDate
        endDate
        nextDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      liquidAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      depots {
        items {
          id
          number
          balance
          twr
          mwr
          profit
          depotItems {
            items {
              id
              name
              number
              quantity
              value
              valueCurrency
              einstandskurs
              aktuellerKurs
              notRealGUV
              notRealGUVCurrency
              notRealGUVPercentage
              referenceDate
              avaloqAssetId
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      conditions {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
      actions {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const updateProductActionMap = `mutation UpdateProductActionMap($input: UpdateProductActionMapInput!) {
  updateProductActionMap(input: $input) {
    id
    action {
      id
      trigger
      dateFrom
      dateTo
      advisor
      category
      accountType
      existingCustomer
      newCustomer
      tasks
      name
      actionTCLink
      accept
      products {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    product {
      id
      number
      name
      category
      strategy
      recommendedStrategy
      recommendedName
      balanceActual
      balanceStart
      balanceDate
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      statusProduct
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      retirementYear
      stateMachineToken
      wphgInitialAmount
      initialAmountReceived
      wphgExpireDate
      wphg
      balanceClosed
      balanceClosedDate
      createdAt
      depotBalance
      depotItems
      cashoutPlan {
        id
        rate
        counter
        interval
        startDate
        endDate
        nextDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      liquidAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      depots {
        items {
          id
          number
          balance
          twr
          mwr
          profit
          depotItems {
            items {
              id
              name
              number
              quantity
              value
              valueCurrency
              einstandskurs
              aktuellerKurs
              notRealGUV
              notRealGUVCurrency
              notRealGUVPercentage
              referenceDate
              avaloqAssetId
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      conditions {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
      actions {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const deleteProductActionMap = `mutation DeleteProductActionMap($input: DeleteProductActionMapInput!) {
  deleteProductActionMap(input: $input) {
    id
    action {
      id
      trigger
      dateFrom
      dateTo
      advisor
      category
      accountType
      existingCustomer
      newCustomer
      tasks
      name
      actionTCLink
      accept
      products {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    product {
      id
      number
      name
      category
      strategy
      recommendedStrategy
      recommendedName
      balanceActual
      balanceStart
      balanceDate
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      statusProduct
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      retirementYear
      stateMachineToken
      wphgInitialAmount
      initialAmountReceived
      wphgExpireDate
      wphg
      balanceClosed
      balanceClosedDate
      createdAt
      depotBalance
      depotItems
      cashoutPlan {
        id
        rate
        counter
        interval
        startDate
        endDate
        nextDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      liquidAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      depots {
        items {
          id
          number
          balance
          twr
          mwr
          profit
          depotItems {
            items {
              id
              name
              number
              quantity
              value
              valueCurrency
              einstandskurs
              aktuellerKurs
              notRealGUV
              notRealGUVCurrency
              notRealGUVPercentage
              referenceDate
              avaloqAssetId
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      conditions {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
      actions {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const createAction = `mutation CreateAction($input: CreateActionInput!) {
  createAction(input: $input) {
    id
    trigger
    dateFrom
    dateTo
    advisor
    category
    accountType
    existingCustomer
    newCustomer
    tasks
    name
    actionTCLink
    accept
    products {
      items {
        id
        action {
          id
          trigger
          dateFrom
          dateTo
          advisor
          category
          accountType
          existingCustomer
          newCustomer
          tasks
          name
          actionTCLink
          accept
          products {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const updateAction = `mutation UpdateAction($input: UpdateActionInput!) {
  updateAction(input: $input) {
    id
    trigger
    dateFrom
    dateTo
    advisor
    category
    accountType
    existingCustomer
    newCustomer
    tasks
    name
    actionTCLink
    accept
    products {
      items {
        id
        action {
          id
          trigger
          dateFrom
          dateTo
          advisor
          category
          accountType
          existingCustomer
          newCustomer
          tasks
          name
          actionTCLink
          accept
          products {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const deleteAction = `mutation DeleteAction($input: DeleteActionInput!) {
  deleteAction(input: $input) {
    id
    trigger
    dateFrom
    dateTo
    advisor
    category
    accountType
    existingCustomer
    newCustomer
    tasks
    name
    actionTCLink
    accept
    products {
      items {
        id
        action {
          id
          trigger
          dateFrom
          dateTo
          advisor
          category
          accountType
          existingCustomer
          newCustomer
          tasks
          name
          actionTCLink
          accept
          products {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        product {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const createDepot = `mutation CreateDepot($input: CreateDepotInput!) {
  createDepot(input: $input) {
    id
    number
    balance
    twr
    mwr
    profit
    depotItems {
      items {
        id
        name
        number
        quantity
        value
        valueCurrency
        einstandskurs
        aktuellerKurs
        notRealGUV
        notRealGUVCurrency
        notRealGUVPercentage
        referenceDate
        avaloqAssetId
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const updateDepot = `mutation UpdateDepot($input: UpdateDepotInput!) {
  updateDepot(input: $input) {
    id
    number
    balance
    twr
    mwr
    profit
    depotItems {
      items {
        id
        name
        number
        quantity
        value
        valueCurrency
        einstandskurs
        aktuellerKurs
        notRealGUV
        notRealGUVCurrency
        notRealGUVPercentage
        referenceDate
        avaloqAssetId
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const deleteDepot = `mutation DeleteDepot($input: DeleteDepotInput!) {
  deleteDepot(input: $input) {
    id
    number
    balance
    twr
    mwr
    profit
    depotItems {
      items {
        id
        name
        number
        quantity
        value
        valueCurrency
        einstandskurs
        aktuellerKurs
        notRealGUV
        notRealGUVCurrency
        notRealGUVPercentage
        referenceDate
        avaloqAssetId
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const createDepotItem = `mutation CreateDepotItem($input: CreateDepotItemInput!) {
  createDepotItem(input: $input) {
    id
    name
    number
    quantity
    value
    valueCurrency
    einstandskurs
    aktuellerKurs
    notRealGUV
    notRealGUVCurrency
    notRealGUVPercentage
    referenceDate
    avaloqAssetId
    owner
    members
  }
}
`;
export const updateDepotItem = `mutation UpdateDepotItem($input: UpdateDepotItemInput!) {
  updateDepotItem(input: $input) {
    id
    name
    number
    quantity
    value
    valueCurrency
    einstandskurs
    aktuellerKurs
    notRealGUV
    notRealGUVCurrency
    notRealGUVPercentage
    referenceDate
    avaloqAssetId
    owner
    members
  }
}
`;
export const deleteDepotItem = `mutation DeleteDepotItem($input: DeleteDepotItemInput!) {
  deleteDepotItem(input: $input) {
    id
    name
    number
    quantity
    value
    valueCurrency
    einstandskurs
    aktuellerKurs
    notRealGUV
    notRealGUVCurrency
    notRealGUVPercentage
    referenceDate
    avaloqAssetId
    owner
    members
  }
}
`;
export const createAsset = `mutation CreateAsset($input: CreateAssetInput!) {
  createAsset(input: $input) {
    id
    isin
    name
    colorCode
    kiid
    class
    region
    category
    riskClass
    rate
    currency
    exchangeRate
    dateLastRate
    shortName
    avaloqAssetId
    assetClass1
    assetClass2
    ter
    depotItems {
      items {
        id
        name
        number
        quantity
        value
        valueCurrency
        einstandskurs
        aktuellerKurs
        notRealGUV
        notRealGUVCurrency
        notRealGUVPercentage
        referenceDate
        avaloqAssetId
        owner
        members
      }
      nextToken
    }
  }
}
`;
export const updateAsset = `mutation UpdateAsset($input: UpdateAssetInput!) {
  updateAsset(input: $input) {
    id
    isin
    name
    colorCode
    kiid
    class
    region
    category
    riskClass
    rate
    currency
    exchangeRate
    dateLastRate
    shortName
    avaloqAssetId
    assetClass1
    assetClass2
    ter
    depotItems {
      items {
        id
        name
        number
        quantity
        value
        valueCurrency
        einstandskurs
        aktuellerKurs
        notRealGUV
        notRealGUVCurrency
        notRealGUVPercentage
        referenceDate
        avaloqAssetId
        owner
        members
      }
      nextToken
    }
  }
}
`;
export const deleteAsset = `mutation DeleteAsset($input: DeleteAssetInput!) {
  deleteAsset(input: $input) {
    id
    isin
    name
    colorCode
    kiid
    class
    region
    category
    riskClass
    rate
    currency
    exchangeRate
    dateLastRate
    shortName
    avaloqAssetId
    assetClass1
    assetClass2
    ter
    depotItems {
      items {
        id
        name
        number
        quantity
        value
        valueCurrency
        einstandskurs
        aktuellerKurs
        notRealGUV
        notRealGUVCurrency
        notRealGUVPercentage
        referenceDate
        avaloqAssetId
        owner
        members
      }
      nextToken
    }
  }
}
`;
export const createSavingsPlan = `mutation CreateSavingsPlan($input: CreateSavingsPlanInput!) {
  createSavingsPlan(input: $input) {
    id
    name
    rate
    startDate
    endDate
    nextDate
    executionDay
    counter
    interval
    mandat
    mandatSignatureDate
    bankAccount {
      id
      number
      name
      accountHolder
      iban
      bic
      currency
      exchangeRate
      accountType
      balance
      balanceEur
      reference
      eod
      eodDate
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      transactions {
        items {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const updateSavingsPlan = `mutation UpdateSavingsPlan($input: UpdateSavingsPlanInput!) {
  updateSavingsPlan(input: $input) {
    id
    name
    rate
    startDate
    endDate
    nextDate
    executionDay
    counter
    interval
    mandat
    mandatSignatureDate
    bankAccount {
      id
      number
      name
      accountHolder
      iban
      bic
      currency
      exchangeRate
      accountType
      balance
      balanceEur
      reference
      eod
      eodDate
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      transactions {
        items {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const deleteSavingsPlan = `mutation DeleteSavingsPlan($input: DeleteSavingsPlanInput!) {
  deleteSavingsPlan(input: $input) {
    id
    name
    rate
    startDate
    endDate
    nextDate
    executionDay
    counter
    interval
    mandat
    mandatSignatureDate
    bankAccount {
      id
      number
      name
      accountHolder
      iban
      bic
      currency
      exchangeRate
      accountType
      balance
      balanceEur
      reference
      eod
      eodDate
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      transactions {
        items {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const createCashoutPlan = `mutation CreateCashoutPlan($input: CreateCashoutPlanInput!) {
  createCashoutPlan(input: $input) {
    id
    rate
    counter
    interval
    startDate
    endDate
    nextDate
    bankAccount {
      id
      number
      name
      accountHolder
      iban
      bic
      currency
      exchangeRate
      accountType
      balance
      balanceEur
      reference
      eod
      eodDate
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      transactions {
        items {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const updateCashoutPlan = `mutation UpdateCashoutPlan($input: UpdateCashoutPlanInput!) {
  updateCashoutPlan(input: $input) {
    id
    rate
    counter
    interval
    startDate
    endDate
    nextDate
    bankAccount {
      id
      number
      name
      accountHolder
      iban
      bic
      currency
      exchangeRate
      accountType
      balance
      balanceEur
      reference
      eod
      eodDate
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      transactions {
        items {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const deleteCashoutPlan = `mutation DeleteCashoutPlan($input: DeleteCashoutPlanInput!) {
  deleteCashoutPlan(input: $input) {
    id
    rate
    counter
    interval
    startDate
    endDate
    nextDate
    bankAccount {
      id
      number
      name
      accountHolder
      iban
      bic
      currency
      exchangeRate
      accountType
      balance
      balanceEur
      reference
      eod
      eodDate
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      transactions {
        items {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const createBankAccount = `mutation CreateBankAccount($input: CreateBankAccountInput!) {
  createBankAccount(input: $input) {
    id
    number
    name
    accountHolder
    iban
    bic
    currency
    exchangeRate
    accountType
    balance
    balanceEur
    reference
    eod
    eodDate
    savingsPlans {
      items {
        id
        name
        rate
        startDate
        endDate
        nextDate
        executionDay
        counter
        interval
        mandat
        mandatSignatureDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    transactions {
      items {
        id
        number
        amount
        currency
        valutaDate
        bookingDate
        sequenceNumber
        ktoText
        mandat
        mandatSignatureDate
        auftrag
        metaTyp
        auftragsArt
        ereignis
        ereignisStatus
        internalBookingText
        externalBookingText
        status
        createdAt
        updatedAt
        sfType
        sfARN
        stateMachineToken
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const updateBankAccount = `mutation UpdateBankAccount($input: UpdateBankAccountInput!) {
  updateBankAccount(input: $input) {
    id
    number
    name
    accountHolder
    iban
    bic
    currency
    exchangeRate
    accountType
    balance
    balanceEur
    reference
    eod
    eodDate
    savingsPlans {
      items {
        id
        name
        rate
        startDate
        endDate
        nextDate
        executionDay
        counter
        interval
        mandat
        mandatSignatureDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    transactions {
      items {
        id
        number
        amount
        currency
        valutaDate
        bookingDate
        sequenceNumber
        ktoText
        mandat
        mandatSignatureDate
        auftrag
        metaTyp
        auftragsArt
        ereignis
        ereignisStatus
        internalBookingText
        externalBookingText
        status
        createdAt
        updatedAt
        sfType
        sfARN
        stateMachineToken
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const deleteBankAccount = `mutation DeleteBankAccount($input: DeleteBankAccountInput!) {
  deleteBankAccount(input: $input) {
    id
    number
    name
    accountHolder
    iban
    bic
    currency
    exchangeRate
    accountType
    balance
    balanceEur
    reference
    eod
    eodDate
    savingsPlans {
      items {
        id
        name
        rate
        startDate
        endDate
        nextDate
        executionDay
        counter
        interval
        mandat
        mandatSignatureDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    transactions {
      items {
        id
        number
        amount
        currency
        valutaDate
        bookingDate
        sequenceNumber
        ktoText
        mandat
        mandatSignatureDate
        auftrag
        metaTyp
        auftragsArt
        ereignis
        ereignisStatus
        internalBookingText
        externalBookingText
        status
        createdAt
        updatedAt
        sfType
        sfARN
        stateMachineToken
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const createTransactionPending = `mutation CreateTransactionPending($input: CreateTransactionPendingInput!) {
  createTransactionPending(input: $input) {
    id
    number
    ktoText
    mandat
    amount
    currency
    status
    mandatSignatureDate
    createdAt
    sfType
    sfARN
    stateMachineToken
    productId
    businessPartnerId
    owner
    members
  }
}
`;
export const updateTransactionPending = `mutation UpdateTransactionPending($input: UpdateTransactionPendingInput!) {
  updateTransactionPending(input: $input) {
    id
    number
    ktoText
    mandat
    amount
    currency
    status
    mandatSignatureDate
    createdAt
    sfType
    sfARN
    stateMachineToken
    productId
    businessPartnerId
    owner
    members
  }
}
`;
export const deleteTransactionPending = `mutation DeleteTransactionPending($input: DeleteTransactionPendingInput!) {
  deleteTransactionPending(input: $input) {
    id
    number
    ktoText
    mandat
    amount
    currency
    status
    mandatSignatureDate
    createdAt
    sfType
    sfARN
    stateMachineToken
    productId
    businessPartnerId
    owner
    members
  }
}
`;
export const createTransaction = `mutation CreateTransaction($input: CreateTransactionInput!) {
  createTransaction(input: $input) {
    id
    number
    amount
    currency
    valutaDate
    bookingDate
    sequenceNumber
    ktoText
    mandat
    mandatSignatureDate
    auftrag
    metaTyp
    auftragsArt
    ereignis
    ereignisStatus
    internalBookingText
    externalBookingText
    status
    createdAt
    updatedAt
    sfType
    sfARN
    stateMachineToken
    bankAccount {
      id
      number
      name
      accountHolder
      iban
      bic
      currency
      exchangeRate
      accountType
      balance
      balanceEur
      reference
      eod
      eodDate
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      transactions {
        items {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const updateTransaction = `mutation UpdateTransaction($input: UpdateTransactionInput!) {
  updateTransaction(input: $input) {
    id
    number
    amount
    currency
    valutaDate
    bookingDate
    sequenceNumber
    ktoText
    mandat
    mandatSignatureDate
    auftrag
    metaTyp
    auftragsArt
    ereignis
    ereignisStatus
    internalBookingText
    externalBookingText
    status
    createdAt
    updatedAt
    sfType
    sfARN
    stateMachineToken
    bankAccount {
      id
      number
      name
      accountHolder
      iban
      bic
      currency
      exchangeRate
      accountType
      balance
      balanceEur
      reference
      eod
      eodDate
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      transactions {
        items {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const deleteTransaction = `mutation DeleteTransaction($input: DeleteTransactionInput!) {
  deleteTransaction(input: $input) {
    id
    number
    amount
    currency
    valutaDate
    bookingDate
    sequenceNumber
    ktoText
    mandat
    mandatSignatureDate
    auftrag
    metaTyp
    auftragsArt
    ereignis
    ereignisStatus
    internalBookingText
    externalBookingText
    status
    createdAt
    updatedAt
    sfType
    sfARN
    stateMachineToken
    bankAccount {
      id
      number
      name
      accountHolder
      iban
      bic
      currency
      exchangeRate
      accountType
      balance
      balanceEur
      reference
      eod
      eodDate
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      transactions {
        items {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const createPostbox = `mutation CreatePostbox($input: CreatePostboxInput!) {
  createPostbox(input: $input) {
    id
    title
    date
    readTime
    status
    documentKey
    searchField
    person {
      id
      eMail
      externalId
      avaloqId
      postIdent
      communicationEMail
      communicationEMailVerified
      dataComplete
      needToMigrateDoc
      identityId
      gender
      salutation
      title
      titleAdd
      firstName
      middleName
      lastName
      phoneNumber
      mobilePhoneNumber
      passportNumber
      passportIssuer
      passportIssuerDate
      passportValidToDate
      passportPlaceOfIssue
      passportCountryOfIssuer
      birthCertificateNumber
      birthCertificateIssuer
      birthCertificateIssuerDate
      birthCertificateCountryOfIssuer
      birthCertificateInitialEMail
      nationality
      street
      streetNumber
      zip
      city
      state
      country
      addressType
      maritalStatus
      taxNumber
      birthday
      birthplace
      nativeCountry
      occupation
      occupationIndustry
      taxOnlyInGermany
      additionalTax
      mmw
      campaign
      postIdentCaseId
      identificationMethod
      identificationStatus
      identificationType
      utmSource
      utmMedium
      utmCampaign
      utmData
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
      businessPartners {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      postbox {
        items {
          id
          title
          date
          readTime
          status
          documentKey
          searchField
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const updatePostbox = `mutation UpdatePostbox($input: UpdatePostboxInput!) {
  updatePostbox(input: $input) {
    id
    title
    date
    readTime
    status
    documentKey
    searchField
    person {
      id
      eMail
      externalId
      avaloqId
      postIdent
      communicationEMail
      communicationEMailVerified
      dataComplete
      needToMigrateDoc
      identityId
      gender
      salutation
      title
      titleAdd
      firstName
      middleName
      lastName
      phoneNumber
      mobilePhoneNumber
      passportNumber
      passportIssuer
      passportIssuerDate
      passportValidToDate
      passportPlaceOfIssue
      passportCountryOfIssuer
      birthCertificateNumber
      birthCertificateIssuer
      birthCertificateIssuerDate
      birthCertificateCountryOfIssuer
      birthCertificateInitialEMail
      nationality
      street
      streetNumber
      zip
      city
      state
      country
      addressType
      maritalStatus
      taxNumber
      birthday
      birthplace
      nativeCountry
      occupation
      occupationIndustry
      taxOnlyInGermany
      additionalTax
      mmw
      campaign
      postIdentCaseId
      identificationMethod
      identificationStatus
      identificationType
      utmSource
      utmMedium
      utmCampaign
      utmData
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
      businessPartners {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      postbox {
        items {
          id
          title
          date
          readTime
          status
          documentKey
          searchField
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const deletePostbox = `mutation DeletePostbox($input: DeletePostboxInput!) {
  deletePostbox(input: $input) {
    id
    title
    date
    readTime
    status
    documentKey
    searchField
    person {
      id
      eMail
      externalId
      avaloqId
      postIdent
      communicationEMail
      communicationEMailVerified
      dataComplete
      needToMigrateDoc
      identityId
      gender
      salutation
      title
      titleAdd
      firstName
      middleName
      lastName
      phoneNumber
      mobilePhoneNumber
      passportNumber
      passportIssuer
      passportIssuerDate
      passportValidToDate
      passportPlaceOfIssue
      passportCountryOfIssuer
      birthCertificateNumber
      birthCertificateIssuer
      birthCertificateIssuerDate
      birthCertificateCountryOfIssuer
      birthCertificateInitialEMail
      nationality
      street
      streetNumber
      zip
      city
      state
      country
      addressType
      maritalStatus
      taxNumber
      birthday
      birthplace
      nativeCountry
      occupation
      occupationIndustry
      taxOnlyInGermany
      additionalTax
      mmw
      campaign
      postIdentCaseId
      identificationMethod
      identificationStatus
      identificationType
      utmSource
      utmMedium
      utmCampaign
      utmData
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
      businessPartners {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      postbox {
        items {
          id
          title
          date
          readTime
          status
          documentKey
          searchField
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const createOrder = `mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    id
    productId
    businessPartnerId
    personId
    amount
    sfType
    sfARN
    sfStartDate
    status
    createdAt
    EndOfStateMachine
    stateMachineToken
    product {
      id
      number
      name
      category
      strategy
      recommendedStrategy
      recommendedName
      balanceActual
      balanceStart
      balanceDate
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      statusProduct
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      retirementYear
      stateMachineToken
      wphgInitialAmount
      initialAmountReceived
      wphgExpireDate
      wphg
      balanceClosed
      balanceClosedDate
      createdAt
      depotBalance
      depotItems
      cashoutPlan {
        id
        rate
        counter
        interval
        startDate
        endDate
        nextDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      liquidAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      depots {
        items {
          id
          number
          balance
          twr
          mwr
          profit
          depotItems {
            items {
              id
              name
              number
              quantity
              value
              valueCurrency
              einstandskurs
              aktuellerKurs
              notRealGUV
              notRealGUVCurrency
              notRealGUVPercentage
              referenceDate
              avaloqAssetId
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      conditions {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
      actions {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    businessPartner {
      id
      number
      accountType
      name
      statusContract
      avaloqSync
      advisor
      branch
      balanceActual
      balanceDate
      balanceStart
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      joinedMember
      childMember
      otherMembers
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      stateMachineToken
      createdAt
      openedAt
      closedAt
      wphgExpireDate
      wphg
      businessPartnerCode {
        items {
          id
          attorney
          businessPartnerId
          accountCode
          accountCodeStatus
          acceptedByOwner
          owner
          members
        }
        nextToken
      }
      persons {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      products {
        items {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      bankAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    person {
      id
      eMail
      externalId
      avaloqId
      postIdent
      communicationEMail
      communicationEMailVerified
      dataComplete
      needToMigrateDoc
      identityId
      gender
      salutation
      title
      titleAdd
      firstName
      middleName
      lastName
      phoneNumber
      mobilePhoneNumber
      passportNumber
      passportIssuer
      passportIssuerDate
      passportValidToDate
      passportPlaceOfIssue
      passportCountryOfIssuer
      birthCertificateNumber
      birthCertificateIssuer
      birthCertificateIssuerDate
      birthCertificateCountryOfIssuer
      birthCertificateInitialEMail
      nationality
      street
      streetNumber
      zip
      city
      state
      country
      addressType
      maritalStatus
      taxNumber
      birthday
      birthplace
      nativeCountry
      occupation
      occupationIndustry
      taxOnlyInGermany
      additionalTax
      mmw
      campaign
      postIdentCaseId
      identificationMethod
      identificationStatus
      identificationType
      utmSource
      utmMedium
      utmCampaign
      utmData
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
      businessPartners {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      postbox {
        items {
          id
          title
          date
          readTime
          status
          documentKey
          searchField
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    subOrder {
      items {
        id
        chain
        amount
        status
        type
        createdAt
        transaction {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        order {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const updateOrder = `mutation UpdateOrder($input: UpdateOrderInput!) {
  updateOrder(input: $input) {
    id
    productId
    businessPartnerId
    personId
    amount
    sfType
    sfARN
    sfStartDate
    status
    createdAt
    EndOfStateMachine
    stateMachineToken
    product {
      id
      number
      name
      category
      strategy
      recommendedStrategy
      recommendedName
      balanceActual
      balanceStart
      balanceDate
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      statusProduct
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      retirementYear
      stateMachineToken
      wphgInitialAmount
      initialAmountReceived
      wphgExpireDate
      wphg
      balanceClosed
      balanceClosedDate
      createdAt
      depotBalance
      depotItems
      cashoutPlan {
        id
        rate
        counter
        interval
        startDate
        endDate
        nextDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      liquidAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      depots {
        items {
          id
          number
          balance
          twr
          mwr
          profit
          depotItems {
            items {
              id
              name
              number
              quantity
              value
              valueCurrency
              einstandskurs
              aktuellerKurs
              notRealGUV
              notRealGUVCurrency
              notRealGUVPercentage
              referenceDate
              avaloqAssetId
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      conditions {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
      actions {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    businessPartner {
      id
      number
      accountType
      name
      statusContract
      avaloqSync
      advisor
      branch
      balanceActual
      balanceDate
      balanceStart
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      joinedMember
      childMember
      otherMembers
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      stateMachineToken
      createdAt
      openedAt
      closedAt
      wphgExpireDate
      wphg
      businessPartnerCode {
        items {
          id
          attorney
          businessPartnerId
          accountCode
          accountCodeStatus
          acceptedByOwner
          owner
          members
        }
        nextToken
      }
      persons {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      products {
        items {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      bankAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    person {
      id
      eMail
      externalId
      avaloqId
      postIdent
      communicationEMail
      communicationEMailVerified
      dataComplete
      needToMigrateDoc
      identityId
      gender
      salutation
      title
      titleAdd
      firstName
      middleName
      lastName
      phoneNumber
      mobilePhoneNumber
      passportNumber
      passportIssuer
      passportIssuerDate
      passportValidToDate
      passportPlaceOfIssue
      passportCountryOfIssuer
      birthCertificateNumber
      birthCertificateIssuer
      birthCertificateIssuerDate
      birthCertificateCountryOfIssuer
      birthCertificateInitialEMail
      nationality
      street
      streetNumber
      zip
      city
      state
      country
      addressType
      maritalStatus
      taxNumber
      birthday
      birthplace
      nativeCountry
      occupation
      occupationIndustry
      taxOnlyInGermany
      additionalTax
      mmw
      campaign
      postIdentCaseId
      identificationMethod
      identificationStatus
      identificationType
      utmSource
      utmMedium
      utmCampaign
      utmData
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
      businessPartners {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      postbox {
        items {
          id
          title
          date
          readTime
          status
          documentKey
          searchField
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    subOrder {
      items {
        id
        chain
        amount
        status
        type
        createdAt
        transaction {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        order {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const deleteOrder = `mutation DeleteOrder($input: DeleteOrderInput!) {
  deleteOrder(input: $input) {
    id
    productId
    businessPartnerId
    personId
    amount
    sfType
    sfARN
    sfStartDate
    status
    createdAt
    EndOfStateMachine
    stateMachineToken
    product {
      id
      number
      name
      category
      strategy
      recommendedStrategy
      recommendedName
      balanceActual
      balanceStart
      balanceDate
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      statusProduct
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      retirementYear
      stateMachineToken
      wphgInitialAmount
      initialAmountReceived
      wphgExpireDate
      wphg
      balanceClosed
      balanceClosedDate
      createdAt
      depotBalance
      depotItems
      cashoutPlan {
        id
        rate
        counter
        interval
        startDate
        endDate
        nextDate
        bankAccount {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      liquidAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      savingsPlans {
        items {
          id
          name
          rate
          startDate
          endDate
          nextDate
          executionDay
          counter
          interval
          mandat
          mandatSignatureDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      depots {
        items {
          id
          number
          balance
          twr
          mwr
          profit
          depotItems {
            items {
              id
              name
              number
              quantity
              value
              valueCurrency
              einstandskurs
              aktuellerKurs
              notRealGUV
              notRealGUVCurrency
              notRealGUVPercentage
              referenceDate
              avaloqAssetId
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      conditions {
        items {
          id
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          condition {
            id
            advisor
            category
            strategy
            accountType
            minInvest
            minIncrease
            minDecrease
            minRate
            allowance
            cashoutplan
            savingsplan
            consulting
            feeQuirion
            feeAdvisor
            validFrom
            validTo
            homepageUrl
            conditionLink
            advisorConfirmText
            contact
            phoneNumber
            description
            descriptionTitle
            title
            name
            newBp
            newIps
            costProfile
            products {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
          }
          owner
          members
        }
        nextToken
      }
      actions {
        items {
          id
          action {
            id
            trigger
            dateFrom
            dateTo
            advisor
            category
            accountType
            existingCustomer
            newCustomer
            tasks
            name
            actionTCLink
            accept
            products {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    businessPartner {
      id
      number
      accountType
      name
      statusContract
      avaloqSync
      advisor
      branch
      balanceActual
      balanceDate
      balanceStart
      totalChangeBegin
      totalChangeYearStart
      twrPerformanceStart
      twrPerformanceYearStart
      mwrPerformanceStart
      mwrPerformanceYearStart
      joinedMember
      childMember
      otherMembers
      portfolioHistory
      portfolioHistoryYear
      performanceStartDate
      stateMachineToken
      createdAt
      openedAt
      closedAt
      wphgExpireDate
      wphg
      businessPartnerCode {
        items {
          id
          attorney
          businessPartnerId
          accountCode
          accountCodeStatus
          acceptedByOwner
          owner
          members
        }
        nextToken
      }
      persons {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      products {
        items {
          id
          number
          name
          category
          strategy
          recommendedStrategy
          recommendedName
          balanceActual
          balanceStart
          balanceDate
          totalChangeBegin
          totalChangeYearStart
          twrPerformanceStart
          twrPerformanceYearStart
          mwrPerformanceStart
          mwrPerformanceYearStart
          statusProduct
          portfolioHistory
          portfolioHistoryYear
          performanceStartDate
          retirementYear
          stateMachineToken
          wphgInitialAmount
          initialAmountReceived
          wphgExpireDate
          wphg
          balanceClosed
          balanceClosedDate
          createdAt
          depotBalance
          depotItems
          cashoutPlan {
            id
            rate
            counter
            interval
            startDate
            endDate
            nextDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          liquidAccounts {
            items {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          depots {
            items {
              id
              number
              balance
              twr
              mwr
              profit
              depotItems {
                items {
                  id
                  name
                  number
                  quantity
                  value
                  valueCurrency
                  einstandskurs
                  aktuellerKurs
                  notRealGUV
                  notRealGUVCurrency
                  notRealGUVPercentage
                  referenceDate
                  avaloqAssetId
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          orders {
            items {
              id
              productId
              businessPartnerId
              personId
              amount
              sfType
              sfARN
              sfStartDate
              status
              createdAt
              EndOfStateMachine
              stateMachineToken
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              businessPartner {
                id
                number
                accountType
                name
                statusContract
                avaloqSync
                advisor
                branch
                balanceActual
                balanceDate
                balanceStart
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                joinedMember
                childMember
                otherMembers
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                stateMachineToken
                createdAt
                openedAt
                closedAt
                wphgExpireDate
                wphg
                businessPartnerCode {
                  items {
                    id
                    attorney
                    businessPartnerId
                    accountCode
                    accountCodeStatus
                    acceptedByOwner
                    owner
                    members
                  }
                  nextToken
                }
                persons {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                products {
                  items {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                bankAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              person {
                id
                eMail
                externalId
                avaloqId
                postIdent
                communicationEMail
                communicationEMailVerified
                dataComplete
                needToMigrateDoc
                identityId
                gender
                salutation
                title
                titleAdd
                firstName
                middleName
                lastName
                phoneNumber
                mobilePhoneNumber
                passportNumber
                passportIssuer
                passportIssuerDate
                passportValidToDate
                passportPlaceOfIssue
                passportCountryOfIssuer
                birthCertificateNumber
                birthCertificateIssuer
                birthCertificateIssuerDate
                birthCertificateCountryOfIssuer
                birthCertificateInitialEMail
                nationality
                street
                streetNumber
                zip
                city
                state
                country
                addressType
                maritalStatus
                taxNumber
                birthday
                birthplace
                nativeCountry
                occupation
                occupationIndustry
                taxOnlyInGermany
                additionalTax
                mmw
                campaign
                postIdentCaseId
                identificationMethod
                identificationStatus
                identificationType
                utmSource
                utmMedium
                utmCampaign
                utmData
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
                businessPartners {
                  items {
                    id
                    role
                    waitForCode
                    waitForBirthCertificate
                    bpId
                    createdAt
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                postbox {
                  items {
                    id
                    title
                    date
                    readTime
                    status
                    documentKey
                    searchField
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                consultant {
                  id
                  branch
                  branchStreet
                  branchZip
                  branchCity
                  branchState
                  counter
                  firstName
                  lastName
                  email
                  phoneNumber
                  mobilePhoneNumber
                  status
                  s3BucketPicLink
                  createdAt
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                }
                owner
                members
              }
              subOrder {
                items {
                  id
                  chain
                  amount
                  status
                  type
                  createdAt
                  transaction {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  order {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            nextToken
          }
          conditions {
            items {
              id
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              condition {
                id
                advisor
                category
                strategy
                accountType
                minInvest
                minIncrease
                minDecrease
                minRate
                allowance
                cashoutplan
                savingsplan
                consulting
                feeQuirion
                feeAdvisor
                validFrom
                validTo
                homepageUrl
                conditionLink
                advisorConfirmText
                contact
                phoneNumber
                description
                descriptionTitle
                title
                name
                newBp
                newIps
                costProfile
                products {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
              }
              owner
              members
            }
            nextToken
          }
          actions {
            items {
              id
              action {
                id
                trigger
                dateFrom
                dateTo
                advisor
                category
                accountType
                existingCustomer
                newCustomer
                tasks
                name
                actionTCLink
                accept
                products {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              product {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      bankAccounts {
        items {
          id
          number
          name
          accountHolder
          iban
          bic
          currency
          exchangeRate
          accountType
          balance
          balanceEur
          reference
          eod
          eodDate
          savingsPlans {
            items {
              id
              name
              rate
              startDate
              endDate
              nextDate
              executionDay
              counter
              interval
              mandat
              mandatSignatureDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          transactions {
            items {
              id
              number
              amount
              currency
              valutaDate
              bookingDate
              sequenceNumber
              ktoText
              mandat
              mandatSignatureDate
              auftrag
              metaTyp
              auftragsArt
              ereignis
              ereignisStatus
              internalBookingText
              externalBookingText
              status
              createdAt
              updatedAt
              sfType
              sfARN
              stateMachineToken
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    person {
      id
      eMail
      externalId
      avaloqId
      postIdent
      communicationEMail
      communicationEMailVerified
      dataComplete
      needToMigrateDoc
      identityId
      gender
      salutation
      title
      titleAdd
      firstName
      middleName
      lastName
      phoneNumber
      mobilePhoneNumber
      passportNumber
      passportIssuer
      passportIssuerDate
      passportValidToDate
      passportPlaceOfIssue
      passportCountryOfIssuer
      birthCertificateNumber
      birthCertificateIssuer
      birthCertificateIssuerDate
      birthCertificateCountryOfIssuer
      birthCertificateInitialEMail
      nationality
      street
      streetNumber
      zip
      city
      state
      country
      addressType
      maritalStatus
      taxNumber
      birthday
      birthplace
      nativeCountry
      occupation
      occupationIndustry
      taxOnlyInGermany
      additionalTax
      mmw
      campaign
      postIdentCaseId
      identificationMethod
      identificationStatus
      identificationType
      utmSource
      utmMedium
      utmCampaign
      utmData
      ndl {
        id
        name
        city
        zip
        street
        streetNr
      }
      businessPartners {
        items {
          id
          role
          waitForCode
          waitForBirthCertificate
          bpId
          createdAt
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      postbox {
        items {
          id
          title
          date
          readTime
          status
          documentKey
          searchField
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      orders {
        items {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        nextToken
      }
      consultant {
        id
        branch
        branchStreet
        branchZip
        branchCity
        branchState
        counter
        firstName
        lastName
        email
        phoneNumber
        mobilePhoneNumber
        status
        s3BucketPicLink
        createdAt
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
      }
      owner
      members
    }
    subOrder {
      items {
        id
        chain
        amount
        status
        type
        createdAt
        transaction {
          id
          number
          amount
          currency
          valutaDate
          bookingDate
          sequenceNumber
          ktoText
          mandat
          mandatSignatureDate
          auftrag
          metaTyp
          auftragsArt
          ereignis
          ereignisStatus
          internalBookingText
          externalBookingText
          status
          createdAt
          updatedAt
          sfType
          sfARN
          stateMachineToken
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        order {
          id
          productId
          businessPartnerId
          personId
          amount
          sfType
          sfARN
          sfStartDate
          status
          createdAt
          EndOfStateMachine
          stateMachineToken
          product {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          businessPartner {
            id
            number
            accountType
            name
            statusContract
            avaloqSync
            advisor
            branch
            balanceActual
            balanceDate
            balanceStart
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            joinedMember
            childMember
            otherMembers
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            stateMachineToken
            createdAt
            openedAt
            closedAt
            wphgExpireDate
            wphg
            businessPartnerCode {
              items {
                id
                attorney
                businessPartnerId
                accountCode
                accountCodeStatus
                acceptedByOwner
                owner
                members
              }
              nextToken
            }
            persons {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            products {
              items {
                id
                number
                name
                category
                strategy
                recommendedStrategy
                recommendedName
                balanceActual
                balanceStart
                balanceDate
                totalChangeBegin
                totalChangeYearStart
                twrPerformanceStart
                twrPerformanceYearStart
                mwrPerformanceStart
                mwrPerformanceYearStart
                statusProduct
                portfolioHistory
                portfolioHistoryYear
                performanceStartDate
                retirementYear
                stateMachineToken
                wphgInitialAmount
                initialAmountReceived
                wphgExpireDate
                wphg
                balanceClosed
                balanceClosedDate
                createdAt
                depotBalance
                depotItems
                cashoutPlan {
                  id
                  rate
                  counter
                  interval
                  startDate
                  endDate
                  nextDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                liquidAccounts {
                  items {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                depots {
                  items {
                    id
                    number
                    balance
                    twr
                    mwr
                    profit
                    depotItems {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                orders {
                  items {
                    id
                    productId
                    businessPartnerId
                    personId
                    amount
                    sfType
                    sfARN
                    sfStartDate
                    status
                    createdAt
                    EndOfStateMachine
                    stateMachineToken
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    businessPartner {
                      id
                      number
                      accountType
                      name
                      statusContract
                      avaloqSync
                      advisor
                      branch
                      balanceActual
                      balanceDate
                      balanceStart
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      joinedMember
                      childMember
                      otherMembers
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      stateMachineToken
                      createdAt
                      openedAt
                      closedAt
                      wphgExpireDate
                      wphg
                      owner
                      members
                    }
                    person {
                      id
                      eMail
                      externalId
                      avaloqId
                      postIdent
                      communicationEMail
                      communicationEMailVerified
                      dataComplete
                      needToMigrateDoc
                      identityId
                      gender
                      salutation
                      title
                      titleAdd
                      firstName
                      middleName
                      lastName
                      phoneNumber
                      mobilePhoneNumber
                      passportNumber
                      passportIssuer
                      passportIssuerDate
                      passportValidToDate
                      passportPlaceOfIssue
                      passportCountryOfIssuer
                      birthCertificateNumber
                      birthCertificateIssuer
                      birthCertificateIssuerDate
                      birthCertificateCountryOfIssuer
                      birthCertificateInitialEMail
                      nationality
                      street
                      streetNumber
                      zip
                      city
                      state
                      country
                      addressType
                      maritalStatus
                      taxNumber
                      birthday
                      birthplace
                      nativeCountry
                      occupation
                      occupationIndustry
                      taxOnlyInGermany
                      additionalTax
                      mmw
                      campaign
                      postIdentCaseId
                      identificationMethod
                      identificationStatus
                      identificationType
                      utmSource
                      utmMedium
                      utmCampaign
                      utmData
                      owner
                      members
                    }
                    subOrder {
                      nextToken
                    }
                    owner
                    members
                  }
                  nextToken
                }
                conditions {
                  items {
                    id
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    condition {
                      id
                      advisor
                      category
                      strategy
                      accountType
                      minInvest
                      minIncrease
                      minDecrease
                      minRate
                      allowance
                      cashoutplan
                      savingsplan
                      consulting
                      feeQuirion
                      feeAdvisor
                      validFrom
                      validTo
                      homepageUrl
                      conditionLink
                      advisorConfirmText
                      contact
                      phoneNumber
                      description
                      descriptionTitle
                      title
                      name
                      newBp
                      newIps
                      costProfile
                    }
                    owner
                    members
                  }
                  nextToken
                }
                actions {
                  items {
                    id
                    action {
                      id
                      trigger
                      dateFrom
                      dateTo
                      advisor
                      category
                      accountType
                      existingCustomer
                      newCustomer
                      tasks
                      name
                      actionTCLink
                      accept
                      owner
                      members
                    }
                    product {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            bankAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          person {
            id
            eMail
            externalId
            avaloqId
            postIdent
            communicationEMail
            communicationEMailVerified
            dataComplete
            needToMigrateDoc
            identityId
            gender
            salutation
            title
            titleAdd
            firstName
            middleName
            lastName
            phoneNumber
            mobilePhoneNumber
            passportNumber
            passportIssuer
            passportIssuerDate
            passportValidToDate
            passportPlaceOfIssue
            passportCountryOfIssuer
            birthCertificateNumber
            birthCertificateIssuer
            birthCertificateIssuerDate
            birthCertificateCountryOfIssuer
            birthCertificateInitialEMail
            nationality
            street
            streetNumber
            zip
            city
            state
            country
            addressType
            maritalStatus
            taxNumber
            birthday
            birthplace
            nativeCountry
            occupation
            occupationIndustry
            taxOnlyInGermany
            additionalTax
            mmw
            campaign
            postIdentCaseId
            identificationMethod
            identificationStatus
            identificationType
            utmSource
            utmMedium
            utmCampaign
            utmData
            ndl {
              id
              name
              city
              zip
              street
              streetNr
            }
            businessPartners {
              items {
                id
                role
                waitForCode
                waitForBirthCertificate
                bpId
                createdAt
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            postbox {
              items {
                id
                title
                date
                readTime
                status
                documentKey
                searchField
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            consultant {
              id
              branch
              branchStreet
              branchZip
              branchCity
              branchState
              counter
              firstName
              lastName
              email
              phoneNumber
              mobilePhoneNumber
              status
              s3BucketPicLink
              createdAt
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
            }
            owner
            members
          }
          subOrder {
            items {
              id
              chain
              amount
              status
              type
              createdAt
              transaction {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              order {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            nextToken
          }
          owner
          members
        }
        owner
        members
      }
      nextToken
    }
    owner
    members
  }
}
`;
export const createSubOrder = `mutation CreateSubOrder($input: CreateSubOrderInput!) {
  createSubOrder(input: $input) {
    id
    chain
    amount
    status
    type
    createdAt
    transaction {
      id
      number
      amount
      currency
      valutaDate
      bookingDate
      sequenceNumber
      ktoText
      mandat
      mandatSignatureDate
      auftrag
      metaTyp
      auftragsArt
      ereignis
      ereignisStatus
      internalBookingText
      externalBookingText
      status
      createdAt
      updatedAt
      sfType
      sfARN
      stateMachineToken
      bankAccount {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      owner
      members
    }
    order {
      id
      productId
      businessPartnerId
      personId
      amount
      sfType
      sfARN
      sfStartDate
      status
      createdAt
      EndOfStateMachine
      stateMachineToken
      product {
        id
        number
        name
        category
        strategy
        recommendedStrategy
        recommendedName
        balanceActual
        balanceStart
        balanceDate
        totalChangeBegin
        totalChangeYearStart
        twrPerformanceStart
        twrPerformanceYearStart
        mwrPerformanceStart
        mwrPerformanceYearStart
        statusProduct
        portfolioHistory
        portfolioHistoryYear
        performanceStartDate
        retirementYear
        stateMachineToken
        wphgInitialAmount
        initialAmountReceived
        wphgExpireDate
        wphg
        balanceClosed
        balanceClosedDate
        createdAt
        depotBalance
        depotItems
        cashoutPlan {
          id
          rate
          counter
          interval
          startDate
          endDate
          nextDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        liquidAccounts {
          items {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        depots {
          items {
            id
            number
            balance
            twr
            mwr
            profit
            depotItems {
              items {
                id
                name
                number
                quantity
                value
                valueCurrency
                einstandskurs
                aktuellerKurs
                notRealGUV
                notRealGUVCurrency
                notRealGUVPercentage
                referenceDate
                avaloqAssetId
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        conditions {
          items {
            id
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            condition {
              id
              advisor
              category
              strategy
              accountType
              minInvest
              minIncrease
              minDecrease
              minRate
              allowance
              cashoutplan
              savingsplan
              consulting
              feeQuirion
              feeAdvisor
              validFrom
              validTo
              homepageUrl
              conditionLink
              advisorConfirmText
              contact
              phoneNumber
              description
              descriptionTitle
              title
              name
              newBp
              newIps
              costProfile
              products {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
            }
            owner
            members
          }
          nextToken
        }
        actions {
          items {
            id
            action {
              id
              trigger
              dateFrom
              dateTo
              advisor
              category
              accountType
              existingCustomer
              newCustomer
              tasks
              name
              actionTCLink
              accept
              products {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      businessPartner {
        id
        number
        accountType
        name
        statusContract
        avaloqSync
        advisor
        branch
        balanceActual
        balanceDate
        balanceStart
        totalChangeBegin
        totalChangeYearStart
        twrPerformanceStart
        twrPerformanceYearStart
        mwrPerformanceStart
        mwrPerformanceYearStart
        joinedMember
        childMember
        otherMembers
        portfolioHistory
        portfolioHistoryYear
        performanceStartDate
        stateMachineToken
        createdAt
        openedAt
        closedAt
        wphgExpireDate
        wphg
        businessPartnerCode {
          items {
            id
            attorney
            businessPartnerId
            accountCode
            accountCodeStatus
            acceptedByOwner
            owner
            members
          }
          nextToken
        }
        persons {
          items {
            id
            role
            waitForCode
            waitForBirthCertificate
            bpId
            createdAt
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        products {
          items {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        bankAccounts {
          items {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        consultant {
          id
          branch
          branchStreet
          branchZip
          branchCity
          branchState
          counter
          firstName
          lastName
          email
          phoneNumber
          mobilePhoneNumber
          status
          s3BucketPicLink
          createdAt
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
        }
        owner
        members
      }
      person {
        id
        eMail
        externalId
        avaloqId
        postIdent
        communicationEMail
        communicationEMailVerified
        dataComplete
        needToMigrateDoc
        identityId
        gender
        salutation
        title
        titleAdd
        firstName
        middleName
        lastName
        phoneNumber
        mobilePhoneNumber
        passportNumber
        passportIssuer
        passportIssuerDate
        passportValidToDate
        passportPlaceOfIssue
        passportCountryOfIssuer
        birthCertificateNumber
        birthCertificateIssuer
        birthCertificateIssuerDate
        birthCertificateCountryOfIssuer
        birthCertificateInitialEMail
        nationality
        street
        streetNumber
        zip
        city
        state
        country
        addressType
        maritalStatus
        taxNumber
        birthday
        birthplace
        nativeCountry
        occupation
        occupationIndustry
        taxOnlyInGermany
        additionalTax
        mmw
        campaign
        postIdentCaseId
        identificationMethod
        identificationStatus
        identificationType
        utmSource
        utmMedium
        utmCampaign
        utmData
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
        businessPartners {
          items {
            id
            role
            waitForCode
            waitForBirthCertificate
            bpId
            createdAt
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        postbox {
          items {
            id
            title
            date
            readTime
            status
            documentKey
            searchField
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        consultant {
          id
          branch
          branchStreet
          branchZip
          branchCity
          branchState
          counter
          firstName
          lastName
          email
          phoneNumber
          mobilePhoneNumber
          status
          s3BucketPicLink
          createdAt
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
        }
        owner
        members
      }
      subOrder {
        items {
          id
          chain
          amount
          status
          type
          createdAt
          transaction {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          order {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const updateSubOrder = `mutation UpdateSubOrder($input: UpdateSubOrderInput!) {
  updateSubOrder(input: $input) {
    id
    chain
    amount
    status
    type
    createdAt
    transaction {
      id
      number
      amount
      currency
      valutaDate
      bookingDate
      sequenceNumber
      ktoText
      mandat
      mandatSignatureDate
      auftrag
      metaTyp
      auftragsArt
      ereignis
      ereignisStatus
      internalBookingText
      externalBookingText
      status
      createdAt
      updatedAt
      sfType
      sfARN
      stateMachineToken
      bankAccount {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      owner
      members
    }
    order {
      id
      productId
      businessPartnerId
      personId
      amount
      sfType
      sfARN
      sfStartDate
      status
      createdAt
      EndOfStateMachine
      stateMachineToken
      product {
        id
        number
        name
        category
        strategy
        recommendedStrategy
        recommendedName
        balanceActual
        balanceStart
        balanceDate
        totalChangeBegin
        totalChangeYearStart
        twrPerformanceStart
        twrPerformanceYearStart
        mwrPerformanceStart
        mwrPerformanceYearStart
        statusProduct
        portfolioHistory
        portfolioHistoryYear
        performanceStartDate
        retirementYear
        stateMachineToken
        wphgInitialAmount
        initialAmountReceived
        wphgExpireDate
        wphg
        balanceClosed
        balanceClosedDate
        createdAt
        depotBalance
        depotItems
        cashoutPlan {
          id
          rate
          counter
          interval
          startDate
          endDate
          nextDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        liquidAccounts {
          items {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        depots {
          items {
            id
            number
            balance
            twr
            mwr
            profit
            depotItems {
              items {
                id
                name
                number
                quantity
                value
                valueCurrency
                einstandskurs
                aktuellerKurs
                notRealGUV
                notRealGUVCurrency
                notRealGUVPercentage
                referenceDate
                avaloqAssetId
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        conditions {
          items {
            id
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            condition {
              id
              advisor
              category
              strategy
              accountType
              minInvest
              minIncrease
              minDecrease
              minRate
              allowance
              cashoutplan
              savingsplan
              consulting
              feeQuirion
              feeAdvisor
              validFrom
              validTo
              homepageUrl
              conditionLink
              advisorConfirmText
              contact
              phoneNumber
              description
              descriptionTitle
              title
              name
              newBp
              newIps
              costProfile
              products {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
            }
            owner
            members
          }
          nextToken
        }
        actions {
          items {
            id
            action {
              id
              trigger
              dateFrom
              dateTo
              advisor
              category
              accountType
              existingCustomer
              newCustomer
              tasks
              name
              actionTCLink
              accept
              products {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      businessPartner {
        id
        number
        accountType
        name
        statusContract
        avaloqSync
        advisor
        branch
        balanceActual
        balanceDate
        balanceStart
        totalChangeBegin
        totalChangeYearStart
        twrPerformanceStart
        twrPerformanceYearStart
        mwrPerformanceStart
        mwrPerformanceYearStart
        joinedMember
        childMember
        otherMembers
        portfolioHistory
        portfolioHistoryYear
        performanceStartDate
        stateMachineToken
        createdAt
        openedAt
        closedAt
        wphgExpireDate
        wphg
        businessPartnerCode {
          items {
            id
            attorney
            businessPartnerId
            accountCode
            accountCodeStatus
            acceptedByOwner
            owner
            members
          }
          nextToken
        }
        persons {
          items {
            id
            role
            waitForCode
            waitForBirthCertificate
            bpId
            createdAt
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        products {
          items {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        bankAccounts {
          items {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        consultant {
          id
          branch
          branchStreet
          branchZip
          branchCity
          branchState
          counter
          firstName
          lastName
          email
          phoneNumber
          mobilePhoneNumber
          status
          s3BucketPicLink
          createdAt
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
        }
        owner
        members
      }
      person {
        id
        eMail
        externalId
        avaloqId
        postIdent
        communicationEMail
        communicationEMailVerified
        dataComplete
        needToMigrateDoc
        identityId
        gender
        salutation
        title
        titleAdd
        firstName
        middleName
        lastName
        phoneNumber
        mobilePhoneNumber
        passportNumber
        passportIssuer
        passportIssuerDate
        passportValidToDate
        passportPlaceOfIssue
        passportCountryOfIssuer
        birthCertificateNumber
        birthCertificateIssuer
        birthCertificateIssuerDate
        birthCertificateCountryOfIssuer
        birthCertificateInitialEMail
        nationality
        street
        streetNumber
        zip
        city
        state
        country
        addressType
        maritalStatus
        taxNumber
        birthday
        birthplace
        nativeCountry
        occupation
        occupationIndustry
        taxOnlyInGermany
        additionalTax
        mmw
        campaign
        postIdentCaseId
        identificationMethod
        identificationStatus
        identificationType
        utmSource
        utmMedium
        utmCampaign
        utmData
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
        businessPartners {
          items {
            id
            role
            waitForCode
            waitForBirthCertificate
            bpId
            createdAt
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        postbox {
          items {
            id
            title
            date
            readTime
            status
            documentKey
            searchField
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        consultant {
          id
          branch
          branchStreet
          branchZip
          branchCity
          branchState
          counter
          firstName
          lastName
          email
          phoneNumber
          mobilePhoneNumber
          status
          s3BucketPicLink
          createdAt
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
        }
        owner
        members
      }
      subOrder {
        items {
          id
          chain
          amount
          status
          type
          createdAt
          transaction {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          order {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
export const deleteSubOrder = `mutation DeleteSubOrder($input: DeleteSubOrderInput!) {
  deleteSubOrder(input: $input) {
    id
    chain
    amount
    status
    type
    createdAt
    transaction {
      id
      number
      amount
      currency
      valutaDate
      bookingDate
      sequenceNumber
      ktoText
      mandat
      mandatSignatureDate
      auftrag
      metaTyp
      auftragsArt
      ereignis
      ereignisStatus
      internalBookingText
      externalBookingText
      status
      createdAt
      updatedAt
      sfType
      sfARN
      stateMachineToken
      bankAccount {
        id
        number
        name
        accountHolder
        iban
        bic
        currency
        exchangeRate
        accountType
        balance
        balanceEur
        reference
        eod
        eodDate
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        transactions {
          items {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      owner
      members
    }
    order {
      id
      productId
      businessPartnerId
      personId
      amount
      sfType
      sfARN
      sfStartDate
      status
      createdAt
      EndOfStateMachine
      stateMachineToken
      product {
        id
        number
        name
        category
        strategy
        recommendedStrategy
        recommendedName
        balanceActual
        balanceStart
        balanceDate
        totalChangeBegin
        totalChangeYearStart
        twrPerformanceStart
        twrPerformanceYearStart
        mwrPerformanceStart
        mwrPerformanceYearStart
        statusProduct
        portfolioHistory
        portfolioHistoryYear
        performanceStartDate
        retirementYear
        stateMachineToken
        wphgInitialAmount
        initialAmountReceived
        wphgExpireDate
        wphg
        balanceClosed
        balanceClosedDate
        createdAt
        depotBalance
        depotItems
        cashoutPlan {
          id
          rate
          counter
          interval
          startDate
          endDate
          nextDate
          bankAccount {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        liquidAccounts {
          items {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        savingsPlans {
          items {
            id
            name
            rate
            startDate
            endDate
            nextDate
            executionDay
            counter
            interval
            mandat
            mandatSignatureDate
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        depots {
          items {
            id
            number
            balance
            twr
            mwr
            profit
            depotItems {
              items {
                id
                name
                number
                quantity
                value
                valueCurrency
                einstandskurs
                aktuellerKurs
                notRealGUV
                notRealGUVCurrency
                notRealGUVPercentage
                referenceDate
                avaloqAssetId
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        conditions {
          items {
            id
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            condition {
              id
              advisor
              category
              strategy
              accountType
              minInvest
              minIncrease
              minDecrease
              minRate
              allowance
              cashoutplan
              savingsplan
              consulting
              feeQuirion
              feeAdvisor
              validFrom
              validTo
              homepageUrl
              conditionLink
              advisorConfirmText
              contact
              phoneNumber
              description
              descriptionTitle
              title
              name
              newBp
              newIps
              costProfile
              products {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
            }
            owner
            members
          }
          nextToken
        }
        actions {
          items {
            id
            action {
              id
              trigger
              dateFrom
              dateTo
              advisor
              category
              accountType
              existingCustomer
              newCustomer
              tasks
              name
              actionTCLink
              accept
              products {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        owner
        members
      }
      businessPartner {
        id
        number
        accountType
        name
        statusContract
        avaloqSync
        advisor
        branch
        balanceActual
        balanceDate
        balanceStart
        totalChangeBegin
        totalChangeYearStart
        twrPerformanceStart
        twrPerformanceYearStart
        mwrPerformanceStart
        mwrPerformanceYearStart
        joinedMember
        childMember
        otherMembers
        portfolioHistory
        portfolioHistoryYear
        performanceStartDate
        stateMachineToken
        createdAt
        openedAt
        closedAt
        wphgExpireDate
        wphg
        businessPartnerCode {
          items {
            id
            attorney
            businessPartnerId
            accountCode
            accountCodeStatus
            acceptedByOwner
            owner
            members
          }
          nextToken
        }
        persons {
          items {
            id
            role
            waitForCode
            waitForBirthCertificate
            bpId
            createdAt
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        products {
          items {
            id
            number
            name
            category
            strategy
            recommendedStrategy
            recommendedName
            balanceActual
            balanceStart
            balanceDate
            totalChangeBegin
            totalChangeYearStart
            twrPerformanceStart
            twrPerformanceYearStart
            mwrPerformanceStart
            mwrPerformanceYearStart
            statusProduct
            portfolioHistory
            portfolioHistoryYear
            performanceStartDate
            retirementYear
            stateMachineToken
            wphgInitialAmount
            initialAmountReceived
            wphgExpireDate
            wphg
            balanceClosed
            balanceClosedDate
            createdAt
            depotBalance
            depotItems
            cashoutPlan {
              id
              rate
              counter
              interval
              startDate
              endDate
              nextDate
              bankAccount {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              owner
              members
            }
            liquidAccounts {
              items {
                id
                number
                name
                accountHolder
                iban
                bic
                currency
                exchangeRate
                accountType
                balance
                balanceEur
                reference
                eod
                eodDate
                savingsPlans {
                  items {
                    id
                    name
                    rate
                    startDate
                    endDate
                    nextDate
                    executionDay
                    counter
                    interval
                    mandat
                    mandatSignatureDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                transactions {
                  items {
                    id
                    number
                    amount
                    currency
                    valutaDate
                    bookingDate
                    sequenceNumber
                    ktoText
                    mandat
                    mandatSignatureDate
                    auftrag
                    metaTyp
                    auftragsArt
                    ereignis
                    ereignisStatus
                    internalBookingText
                    externalBookingText
                    status
                    createdAt
                    updatedAt
                    sfType
                    sfARN
                    stateMachineToken
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            depots {
              items {
                id
                number
                balance
                twr
                mwr
                profit
                depotItems {
                  items {
                    id
                    name
                    number
                    quantity
                    value
                    valueCurrency
                    einstandskurs
                    aktuellerKurs
                    notRealGUV
                    notRealGUVCurrency
                    notRealGUVPercentage
                    referenceDate
                    avaloqAssetId
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            orders {
              items {
                id
                productId
                businessPartnerId
                personId
                amount
                sfType
                sfARN
                sfStartDate
                status
                createdAt
                EndOfStateMachine
                stateMachineToken
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                businessPartner {
                  id
                  number
                  accountType
                  name
                  statusContract
                  avaloqSync
                  advisor
                  branch
                  balanceActual
                  balanceDate
                  balanceStart
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  joinedMember
                  childMember
                  otherMembers
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  stateMachineToken
                  createdAt
                  openedAt
                  closedAt
                  wphgExpireDate
                  wphg
                  businessPartnerCode {
                    items {
                      id
                      attorney
                      businessPartnerId
                      accountCode
                      accountCodeStatus
                      acceptedByOwner
                      owner
                      members
                    }
                    nextToken
                  }
                  persons {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  products {
                    items {
                      id
                      number
                      name
                      category
                      strategy
                      recommendedStrategy
                      recommendedName
                      balanceActual
                      balanceStart
                      balanceDate
                      totalChangeBegin
                      totalChangeYearStart
                      twrPerformanceStart
                      twrPerformanceYearStart
                      mwrPerformanceStart
                      mwrPerformanceYearStart
                      statusProduct
                      portfolioHistory
                      portfolioHistoryYear
                      performanceStartDate
                      retirementYear
                      stateMachineToken
                      wphgInitialAmount
                      initialAmountReceived
                      wphgExpireDate
                      wphg
                      balanceClosed
                      balanceClosedDate
                      createdAt
                      depotBalance
                      depotItems
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  bankAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                person {
                  id
                  eMail
                  externalId
                  avaloqId
                  postIdent
                  communicationEMail
                  communicationEMailVerified
                  dataComplete
                  needToMigrateDoc
                  identityId
                  gender
                  salutation
                  title
                  titleAdd
                  firstName
                  middleName
                  lastName
                  phoneNumber
                  mobilePhoneNumber
                  passportNumber
                  passportIssuer
                  passportIssuerDate
                  passportValidToDate
                  passportPlaceOfIssue
                  passportCountryOfIssuer
                  birthCertificateNumber
                  birthCertificateIssuer
                  birthCertificateIssuerDate
                  birthCertificateCountryOfIssuer
                  birthCertificateInitialEMail
                  nationality
                  street
                  streetNumber
                  zip
                  city
                  state
                  country
                  addressType
                  maritalStatus
                  taxNumber
                  birthday
                  birthplace
                  nativeCountry
                  occupation
                  occupationIndustry
                  taxOnlyInGermany
                  additionalTax
                  mmw
                  campaign
                  postIdentCaseId
                  identificationMethod
                  identificationStatus
                  identificationType
                  utmSource
                  utmMedium
                  utmCampaign
                  utmData
                  ndl {
                    id
                    name
                    city
                    zip
                    street
                    streetNr
                  }
                  businessPartners {
                    items {
                      id
                      role
                      waitForCode
                      waitForBirthCertificate
                      bpId
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  postbox {
                    items {
                      id
                      title
                      date
                      readTime
                      status
                      documentKey
                      searchField
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  consultant {
                    id
                    branch
                    branchStreet
                    branchZip
                    branchCity
                    branchState
                    counter
                    firstName
                    lastName
                    email
                    phoneNumber
                    mobilePhoneNumber
                    status
                    s3BucketPicLink
                    createdAt
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                  }
                  owner
                  members
                }
                subOrder {
                  items {
                    id
                    chain
                    amount
                    status
                    type
                    createdAt
                    transaction {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    order {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    owner
                    members
                  }
                  nextToken
                }
                owner
                members
              }
              nextToken
            }
            conditions {
              items {
                id
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                condition {
                  id
                  advisor
                  category
                  strategy
                  accountType
                  minInvest
                  minIncrease
                  minDecrease
                  minRate
                  allowance
                  cashoutplan
                  savingsplan
                  consulting
                  feeQuirion
                  feeAdvisor
                  validFrom
                  validTo
                  homepageUrl
                  conditionLink
                  advisorConfirmText
                  contact
                  phoneNumber
                  description
                  descriptionTitle
                  title
                  name
                  newBp
                  newIps
                  costProfile
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                }
                owner
                members
              }
              nextToken
            }
            actions {
              items {
                id
                action {
                  id
                  trigger
                  dateFrom
                  dateTo
                  advisor
                  category
                  accountType
                  existingCustomer
                  newCustomer
                  tasks
                  name
                  actionTCLink
                  accept
                  products {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                product {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        bankAccounts {
          items {
            id
            number
            name
            accountHolder
            iban
            bic
            currency
            exchangeRate
            accountType
            balance
            balanceEur
            reference
            eod
            eodDate
            savingsPlans {
              items {
                id
                name
                rate
                startDate
                endDate
                nextDate
                executionDay
                counter
                interval
                mandat
                mandatSignatureDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            transactions {
              items {
                id
                number
                amount
                currency
                valutaDate
                bookingDate
                sequenceNumber
                ktoText
                mandat
                mandatSignatureDate
                auftrag
                metaTyp
                auftragsArt
                ereignis
                ereignisStatus
                internalBookingText
                externalBookingText
                status
                createdAt
                updatedAt
                sfType
                sfARN
                stateMachineToken
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        consultant {
          id
          branch
          branchStreet
          branchZip
          branchCity
          branchState
          counter
          firstName
          lastName
          email
          phoneNumber
          mobilePhoneNumber
          status
          s3BucketPicLink
          createdAt
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
        }
        owner
        members
      }
      person {
        id
        eMail
        externalId
        avaloqId
        postIdent
        communicationEMail
        communicationEMailVerified
        dataComplete
        needToMigrateDoc
        identityId
        gender
        salutation
        title
        titleAdd
        firstName
        middleName
        lastName
        phoneNumber
        mobilePhoneNumber
        passportNumber
        passportIssuer
        passportIssuerDate
        passportValidToDate
        passportPlaceOfIssue
        passportCountryOfIssuer
        birthCertificateNumber
        birthCertificateIssuer
        birthCertificateIssuerDate
        birthCertificateCountryOfIssuer
        birthCertificateInitialEMail
        nationality
        street
        streetNumber
        zip
        city
        state
        country
        addressType
        maritalStatus
        taxNumber
        birthday
        birthplace
        nativeCountry
        occupation
        occupationIndustry
        taxOnlyInGermany
        additionalTax
        mmw
        campaign
        postIdentCaseId
        identificationMethod
        identificationStatus
        identificationType
        utmSource
        utmMedium
        utmCampaign
        utmData
        ndl {
          id
          name
          city
          zip
          street
          streetNr
        }
        businessPartners {
          items {
            id
            role
            waitForCode
            waitForBirthCertificate
            bpId
            createdAt
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        postbox {
          items {
            id
            title
            date
            readTime
            status
            documentKey
            searchField
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            owner
            members
          }
          nextToken
        }
        orders {
          items {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          nextToken
        }
        consultant {
          id
          branch
          branchStreet
          branchZip
          branchCity
          branchState
          counter
          firstName
          lastName
          email
          phoneNumber
          mobilePhoneNumber
          status
          s3BucketPicLink
          createdAt
          ndl {
            id
            name
            city
            zip
            street
            streetNr
          }
        }
        owner
        members
      }
      subOrder {
        items {
          id
          chain
          amount
          status
          type
          createdAt
          transaction {
            id
            number
            amount
            currency
            valutaDate
            bookingDate
            sequenceNumber
            ktoText
            mandat
            mandatSignatureDate
            auftrag
            metaTyp
            auftragsArt
            ereignis
            ereignisStatus
            internalBookingText
            externalBookingText
            status
            createdAt
            updatedAt
            sfType
            sfARN
            stateMachineToken
            bankAccount {
              id
              number
              name
              accountHolder
              iban
              bic
              currency
              exchangeRate
              accountType
              balance
              balanceEur
              reference
              eod
              eodDate
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              transactions {
                items {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            owner
            members
          }
          order {
            id
            productId
            businessPartnerId
            personId
            amount
            sfType
            sfARN
            sfStartDate
            status
            createdAt
            EndOfStateMachine
            stateMachineToken
            product {
              id
              number
              name
              category
              strategy
              recommendedStrategy
              recommendedName
              balanceActual
              balanceStart
              balanceDate
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              statusProduct
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              retirementYear
              stateMachineToken
              wphgInitialAmount
              initialAmountReceived
              wphgExpireDate
              wphg
              balanceClosed
              balanceClosedDate
              createdAt
              depotBalance
              depotItems
              cashoutPlan {
                id
                rate
                counter
                interval
                startDate
                endDate
                nextDate
                bankAccount {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              liquidAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              savingsPlans {
                items {
                  id
                  name
                  rate
                  startDate
                  endDate
                  nextDate
                  executionDay
                  counter
                  interval
                  mandat
                  mandatSignatureDate
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              depots {
                items {
                  id
                  number
                  balance
                  twr
                  mwr
                  profit
                  depotItems {
                    items {
                      id
                      name
                      number
                      quantity
                      value
                      valueCurrency
                      einstandskurs
                      aktuellerKurs
                      notRealGUV
                      notRealGUVCurrency
                      notRealGUVPercentage
                      referenceDate
                      avaloqAssetId
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              conditions {
                items {
                  id
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  condition {
                    id
                    advisor
                    category
                    strategy
                    accountType
                    minInvest
                    minIncrease
                    minDecrease
                    minRate
                    allowance
                    cashoutplan
                    savingsplan
                    consulting
                    feeQuirion
                    feeAdvisor
                    validFrom
                    validTo
                    homepageUrl
                    conditionLink
                    advisorConfirmText
                    contact
                    phoneNumber
                    description
                    descriptionTitle
                    title
                    name
                    newBp
                    newIps
                    costProfile
                    products {
                      nextToken
                    }
                  }
                  owner
                  members
                }
                nextToken
              }
              actions {
                items {
                  id
                  action {
                    id
                    trigger
                    dateFrom
                    dateTo
                    advisor
                    category
                    accountType
                    existingCustomer
                    newCustomer
                    tasks
                    name
                    actionTCLink
                    accept
                    products {
                      nextToken
                    }
                    owner
                    members
                  }
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              owner
              members
            }
            businessPartner {
              id
              number
              accountType
              name
              statusContract
              avaloqSync
              advisor
              branch
              balanceActual
              balanceDate
              balanceStart
              totalChangeBegin
              totalChangeYearStart
              twrPerformanceStart
              twrPerformanceYearStart
              mwrPerformanceStart
              mwrPerformanceYearStart
              joinedMember
              childMember
              otherMembers
              portfolioHistory
              portfolioHistoryYear
              performanceStartDate
              stateMachineToken
              createdAt
              openedAt
              closedAt
              wphgExpireDate
              wphg
              businessPartnerCode {
                items {
                  id
                  attorney
                  businessPartnerId
                  accountCode
                  accountCodeStatus
                  acceptedByOwner
                  owner
                  members
                }
                nextToken
              }
              persons {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              products {
                items {
                  id
                  number
                  name
                  category
                  strategy
                  recommendedStrategy
                  recommendedName
                  balanceActual
                  balanceStart
                  balanceDate
                  totalChangeBegin
                  totalChangeYearStart
                  twrPerformanceStart
                  twrPerformanceYearStart
                  mwrPerformanceStart
                  mwrPerformanceYearStart
                  statusProduct
                  portfolioHistory
                  portfolioHistoryYear
                  performanceStartDate
                  retirementYear
                  stateMachineToken
                  wphgInitialAmount
                  initialAmountReceived
                  wphgExpireDate
                  wphg
                  balanceClosed
                  balanceClosedDate
                  createdAt
                  depotBalance
                  depotItems
                  cashoutPlan {
                    id
                    rate
                    counter
                    interval
                    startDate
                    endDate
                    nextDate
                    bankAccount {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    owner
                    members
                  }
                  liquidAccounts {
                    items {
                      id
                      number
                      name
                      accountHolder
                      iban
                      bic
                      currency
                      exchangeRate
                      accountType
                      balance
                      balanceEur
                      reference
                      eod
                      eodDate
                      owner
                      members
                    }
                    nextToken
                  }
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  depots {
                    items {
                      id
                      number
                      balance
                      twr
                      mwr
                      profit
                      owner
                      members
                    }
                    nextToken
                  }
                  orders {
                    items {
                      id
                      productId
                      businessPartnerId
                      personId
                      amount
                      sfType
                      sfARN
                      sfStartDate
                      status
                      createdAt
                      EndOfStateMachine
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  conditions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  actions {
                    items {
                      id
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              bankAccounts {
                items {
                  id
                  number
                  name
                  accountHolder
                  iban
                  bic
                  currency
                  exchangeRate
                  accountType
                  balance
                  balanceEur
                  reference
                  eod
                  eodDate
                  savingsPlans {
                    items {
                      id
                      name
                      rate
                      startDate
                      endDate
                      nextDate
                      executionDay
                      counter
                      interval
                      mandat
                      mandatSignatureDate
                      owner
                      members
                    }
                    nextToken
                  }
                  transactions {
                    items {
                      id
                      number
                      amount
                      currency
                      valutaDate
                      bookingDate
                      sequenceNumber
                      ktoText
                      mandat
                      mandatSignatureDate
                      auftrag
                      metaTyp
                      auftragsArt
                      ereignis
                      ereignisStatus
                      internalBookingText
                      externalBookingText
                      status
                      createdAt
                      updatedAt
                      sfType
                      sfARN
                      stateMachineToken
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            person {
              id
              eMail
              externalId
              avaloqId
              postIdent
              communicationEMail
              communicationEMailVerified
              dataComplete
              needToMigrateDoc
              identityId
              gender
              salutation
              title
              titleAdd
              firstName
              middleName
              lastName
              phoneNumber
              mobilePhoneNumber
              passportNumber
              passportIssuer
              passportIssuerDate
              passportValidToDate
              passportPlaceOfIssue
              passportCountryOfIssuer
              birthCertificateNumber
              birthCertificateIssuer
              birthCertificateIssuerDate
              birthCertificateCountryOfIssuer
              birthCertificateInitialEMail
              nationality
              street
              streetNumber
              zip
              city
              state
              country
              addressType
              maritalStatus
              taxNumber
              birthday
              birthplace
              nativeCountry
              occupation
              occupationIndustry
              taxOnlyInGermany
              additionalTax
              mmw
              campaign
              postIdentCaseId
              identificationMethod
              identificationStatus
              identificationType
              utmSource
              utmMedium
              utmCampaign
              utmData
              ndl {
                id
                name
                city
                zip
                street
                streetNr
              }
              businessPartners {
                items {
                  id
                  role
                  waitForCode
                  waitForBirthCertificate
                  bpId
                  createdAt
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              postbox {
                items {
                  id
                  title
                  date
                  readTime
                  status
                  documentKey
                  searchField
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                nextToken
              }
              orders {
                items {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                nextToken
              }
              consultant {
                id
                branch
                branchStreet
                branchZip
                branchCity
                branchState
                counter
                firstName
                lastName
                email
                phoneNumber
                mobilePhoneNumber
                status
                s3BucketPicLink
                createdAt
                ndl {
                  id
                  name
                  city
                  zip
                  street
                  streetNr
                }
              }
              owner
              members
            }
            subOrder {
              items {
                id
                chain
                amount
                status
                type
                createdAt
                transaction {
                  id
                  number
                  amount
                  currency
                  valutaDate
                  bookingDate
                  sequenceNumber
                  ktoText
                  mandat
                  mandatSignatureDate
                  auftrag
                  metaTyp
                  auftragsArt
                  ereignis
                  ereignisStatus
                  internalBookingText
                  externalBookingText
                  status
                  createdAt
                  updatedAt
                  sfType
                  sfARN
                  stateMachineToken
                  bankAccount {
                    id
                    number
                    name
                    accountHolder
                    iban
                    bic
                    currency
                    exchangeRate
                    accountType
                    balance
                    balanceEur
                    reference
                    eod
                    eodDate
                    savingsPlans {
                      nextToken
                    }
                    transactions {
                      nextToken
                    }
                    owner
                    members
                  }
                  owner
                  members
                }
                order {
                  id
                  productId
                  businessPartnerId
                  personId
                  amount
                  sfType
                  sfARN
                  sfStartDate
                  status
                  createdAt
                  EndOfStateMachine
                  stateMachineToken
                  product {
                    id
                    number
                    name
                    category
                    strategy
                    recommendedStrategy
                    recommendedName
                    balanceActual
                    balanceStart
                    balanceDate
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    statusProduct
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    retirementYear
                    stateMachineToken
                    wphgInitialAmount
                    initialAmountReceived
                    wphgExpireDate
                    wphg
                    balanceClosed
                    balanceClosedDate
                    createdAt
                    depotBalance
                    depotItems
                    cashoutPlan {
                      id
                      rate
                      counter
                      interval
                      startDate
                      endDate
                      nextDate
                      owner
                      members
                    }
                    liquidAccounts {
                      nextToken
                    }
                    savingsPlans {
                      nextToken
                    }
                    depots {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    conditions {
                      nextToken
                    }
                    actions {
                      nextToken
                    }
                    owner
                    members
                  }
                  businessPartner {
                    id
                    number
                    accountType
                    name
                    statusContract
                    avaloqSync
                    advisor
                    branch
                    balanceActual
                    balanceDate
                    balanceStart
                    totalChangeBegin
                    totalChangeYearStart
                    twrPerformanceStart
                    twrPerformanceYearStart
                    mwrPerformanceStart
                    mwrPerformanceYearStart
                    joinedMember
                    childMember
                    otherMembers
                    portfolioHistory
                    portfolioHistoryYear
                    performanceStartDate
                    stateMachineToken
                    createdAt
                    openedAt
                    closedAt
                    wphgExpireDate
                    wphg
                    businessPartnerCode {
                      nextToken
                    }
                    persons {
                      nextToken
                    }
                    products {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    bankAccounts {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  person {
                    id
                    eMail
                    externalId
                    avaloqId
                    postIdent
                    communicationEMail
                    communicationEMailVerified
                    dataComplete
                    needToMigrateDoc
                    identityId
                    gender
                    salutation
                    title
                    titleAdd
                    firstName
                    middleName
                    lastName
                    phoneNumber
                    mobilePhoneNumber
                    passportNumber
                    passportIssuer
                    passportIssuerDate
                    passportValidToDate
                    passportPlaceOfIssue
                    passportCountryOfIssuer
                    birthCertificateNumber
                    birthCertificateIssuer
                    birthCertificateIssuerDate
                    birthCertificateCountryOfIssuer
                    birthCertificateInitialEMail
                    nationality
                    street
                    streetNumber
                    zip
                    city
                    state
                    country
                    addressType
                    maritalStatus
                    taxNumber
                    birthday
                    birthplace
                    nativeCountry
                    occupation
                    occupationIndustry
                    taxOnlyInGermany
                    additionalTax
                    mmw
                    campaign
                    postIdentCaseId
                    identificationMethod
                    identificationStatus
                    identificationType
                    utmSource
                    utmMedium
                    utmCampaign
                    utmData
                    ndl {
                      id
                      name
                      city
                      zip
                      street
                      streetNr
                    }
                    businessPartners {
                      nextToken
                    }
                    postbox {
                      nextToken
                    }
                    orders {
                      nextToken
                    }
                    consultant {
                      id
                      branch
                      branchStreet
                      branchZip
                      branchCity
                      branchState
                      counter
                      firstName
                      lastName
                      email
                      phoneNumber
                      mobilePhoneNumber
                      status
                      s3BucketPicLink
                      createdAt
                    }
                    owner
                    members
                  }
                  subOrder {
                    items {
                      id
                      chain
                      amount
                      status
                      type
                      createdAt
                      owner
                      members
                    }
                    nextToken
                  }
                  owner
                  members
                }
                owner
                members
              }
              nextToken
            }
            owner
            members
          }
          owner
          members
        }
        nextToken
      }
      owner
      members
    }
    owner
    members
  }
}
`;
